var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundRegistration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2273.819,
    height: 2246.568,
    viewBox: "0 0 2273.819 2246.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 1902.742,
    height: 1866.379,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 1735.152,
    height: 1728.818,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(-0.033 428.003) rotate(-13)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(0.027 0.027)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(87.567 33.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M949.4,1279.305c-1.174-.3-2.674-.255-3.473-.965-9.136-8.114-17.913-16.55-24.635-26.823-6.47-9.887-13.148-19.644-19.636-29.521q-14.976-22.8-29.8-45.7c-2.531-3.911-5.134-7.582-10.226-8.432-1.487-4.135-2.332-8.652-4.6-12.326-4.61-7.474-10.791-14.083-14.872-21.789-7.087-13.381-13.484-27.155-19.42-41.072-8.084-18.953-15.09-38.317-16.906-59.02-.843-9.6-1.238-19.245-1.832-28.873,1.4-9.835,1.924-19.885,4.418-29.441,3.044-11.663-.374-18.95-9.409-27.382-17.035-15.9-35.544-29.8-54.01-43.842-15.775-11.992-31.625-23.945-48.067-35.021-14.383-9.689-29.637-18.132-44.508-27.125l-23.331-13.2-4.789-4.824-3.266-4c-.894-4.11-1.363-8.37-2.8-12.286-1.416-3.85-3.081-8.079-5.934-10.861-6.724-6.556-14.222-12.351-21.406-18.453-8.271-11.005-19.921-18.046-31.164-25.565-5.13-5.966-10.664-11.373-18.853-13.1-1.315-1.946-2.2-4.531-4.023-5.722-6.612-4.307-13.42-8.373-20.419-12.042-2.548-1.336-5.838-1.305-8.79-1.9l-7.754-1.85.049.025-7.522-3.518-16.932-5.23,7.694-3.974c3.313.389,6.732.4,9.913,1.258,4.365,1.182,7.775.407,10.532-3.1,11.657,7.733,25.21,10.724,38.4,14.48,21.268,6.058,42.743,11.42,63.966,17.625,11.311,3.307,19.979,10.357,25.066,21.136.909,1.925,1.938,3.795,2.841,5.721,1.74,3.713,4.342,5.511,8.569,7.147a372.83,372.83,0,0,1,37.676,17.282c10.86,5.665,21.182,12.338,31.616,18.763,4.407,2.715,8.472,5.959,12.722,8.924,17.505,12.209,35.054,24.243,50.535,39.108,12.951,12.436,27.14,23.662,41.132,35.006,4.15,3.365,9.49,5.316,14.285,7.915-2.76,15.381-5.6,30.747-8.257,46.145-2.307,13.369-4.124,26.731-1.147,40.318,2.02,9.217,3.275,10.759,12.98,12.072.236,1.879,1.2,4.051.555,5.576-1.278,3.043-3.457,5.718-5.226,8.568-3.9,6.28-3.8,6.913.608,12.916,5.772,7.859,14.416,11.981,22.112,17.514,10.5,7.549,21.736,9.29,33.9,9.833a28.874,28.874,0,0,1,10.622,2.4c15.9,7.378,31.352,8.45,46.466-1.854,3.359-2.289,6.835-3.826,11.25-2.28,7.776,2.722,13.809-.786,18.98-6.1,2.123-2.181,3.616-4.947,5.711-7.157,4.81-5.074,9.08-11.252,16.7-12.306,7.789-1.077,12.753-5.488,16.91-11.415,3.326-4.744,7.118-9.219,10.017-14.2,19.831-34.055,36.6-69.441,47.656-107.258.685,1.938,1.4,3.866,2.047,5.815,1.6,4.823,2.4,10.084,4.9,14.395,5.316,9.149,12.088,17.5,17.2,26.744,5.669,10.255,11.594,20.488,13.647,32.388.83,4.809,3.7,9.278,5.645,13.9,1.241,4,2.052,8.2,3.8,11.983q12.816,27.691,26.086,55.181c5.005,10.353,10.438,20.506,15.678,30.749l3.818,7.341q1.831,3.649,3.664,7.3.946,1.817,1.894,3.633l5.326,9.347c5.807,11.363,11.661,22.7,17.386,34.105,1.47,2.928,2.532,6.052,3.783,9.087-.423,1.538-1.326,3.121-1.187,4.609.643,6.891,1.513,13.763,2.435,20.624.359,2.676,1.036,5.312,1.629,7.953,1.257,5.6,3.841,11.249,3.561,16.765-.548,10.846,4.514,19.976,7.515,29.707,4.644,15.052,10.157,29.846,14.824,44.894,4.831,15.58,8.983,31.36,13.672,46.985,1.361,4.537,3.539,8.838,5.342,13.246q.971,2.49,1.944,4.982.928,4.538,1.857,9.077l3.587,13.034q.569,4.436,1.142,8.872c-.214,1.137-.863,2.387-.589,3.394q11.7,42.915,23.646,85.766c.452,1.618,1.856,2.979,2.815,4.46l1.354,2.092c-2.472,1.539-2.65,3,.159,4.353,1.144,10.649-1.1,13.855-11.717,16.774-3.019-2.06-6.371-3.778-9.009-6.233a756.2,756.2,0,0,1-91.73-101.587,424.527,424.527,0,0,0-50.582-56.381c-3.408-3.182-6.275-3.8-10.632-2.08-6.547,2.579-13.3,4.963-20.636,3.877-1.221-3.382-2.932-6.3-6.957-7-.88-2.5-1.458-5.151-2.689-7.469-7.523-14.168-15.358-28.091-19.645-43.767a312.731,312.731,0,0,0-12.994-36.7c-5.5-13.3-14.688-23.614-28.641-29.209-11.53-4.624-23.4-3.524-35.52-2.72-.365,1.968-.586,3.429-.91,4.868-2.943,13.052-8.514,16.925-22.09,14.854-4.533-.691-6.489,1.609-7.188,5.121a133.4,133.4,0,0,0-2.187,16.094c-.97,13.039.67,25.878,3.682,38.572",
    transform: "translate(-121.33 -96.038)",
    fill: "#e2e2df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M1159.092,966.267c-1.943-4.624-4.817-9.093-5.647-13.9-2.052-11.9-7.977-22.133-13.647-32.388-5.109-9.245-11.88-17.6-17.2-26.744-2.5-4.311-3.3-9.572-4.9-14.395-.647-1.95-1.362-3.878-2.047-5.816l5.262-12.792c7.467,1.39,12.227-3.529,17.067-7.539,12.229-10.131,24.372-20.385,36.132-31.034,18.495-16.747,30.688-37.7,39.627-60.457,6.2-15.786,11.743-31.851,16.864-48.01,10.1-31.879,25.485-60.921,47.644-86.267,7.771-8.888,16.977-16.555,25.217-25.068,9.962-10.293,20.134-20.462,29.249-31.456,15.2-18.334,31.109-35.922,49.619-51.116,1.1-.9,2.758-1.131,4.158-1.671,1.059,2.345,1.538,5.289,3.289,6.914,4.2,3.9,9.321,6.853,13.477,10.789,7.672,7.269,16.626,13.6,20.6,23.9,1.385,3.59,3.963,4.233,7.279,4.013l3.878,11.168q.936,4.35,1.871,8.7c-6.105,2.177-13.174,2.11-17.732,6.922l4.6,15.331c-1.434,2.929-2.694,5.956-4.335,8.768-4,6.848-7.4,13.827-6.793,22.021l-7.317,5.462c-2.537.863-5.155,1.549-7.6,2.618-10.527,4.608-15.468,5.271-5.894,17.876a7,7,0,0,1,.561.72c2.647,4.656,2.354,6.889-2.248,9.747a34.81,34.81,0,0,1-9.126,3.67c-8.457,2.32-16.992,4.365-26.792,6.848l15.8,27.781q3.647,1.874,7.295,3.745a75.961,75.961,0,0,1,5.072,5.842c2.544,3.573,5.765,7.039,7.018,11.056,1.737,5.575,1.917,11.617,2.765,17.46l-24.183.005c-4.82-.359-6.006.521-4.263,3.681,4.085,7.407,4.155,15.361,4.43,23.416.151,4.4,1.171,8.768,1.8,13.151-2.562,3.63-5.125,7.26-7.4,10.485l39,42.277c-2.017,7.884-9.709,8.571-15.523,10.993-7.886,3.282-11.6,8.172-10.479,16.5.034,6.344-.86,12.856.3,18.992,2.039,10.737.344,20.9-2.427,31.126-1.709,1.922-4.876,3.854-4.855,5.753.061,5.61-2.676,9.536-6.938,13.434,4.325,5.966,8.371,11.514,12.38,17.088,4.631,6.441,3.189,13.807,3.251,20.941-3.459,5.922-8.809,9.879-15.573,8.651-5.976-1.086-11.5-4.545-16.705-6.736-1.045,4.084-2.126,8.308-3.207,12.533-2.642.714-3.291,1.828-1.85,4.525,3.376,6.327,6.331,12.871,9.455,19.327-.678,5.623-.957,11.329-2.141,16.848-1.365,6.358-5.471,9.847-12.56,8.768-5.239-.584-8.859-3.718-12.322-7.273-2.6-2.666-5.509-5.037-8.28-7.54l-1.545,1.139q3.735,12.261,7.471,24.522c.388,2.978.817,5.953,1.157,8.937.659,5.793-2.092,10.325-7.321,12.161-5.935,2.084-9.593.935-13.411-4.208l-6.668-8.984c-.454,2.709.848,4.342,1.424,6.192,1.6,5.145,3.625,10.313,4.151,15.6.7,6.978-2.588,9.044-9.655,7.566-7.448-1.558-12.774-6.173-16.919-11.883a221.991,221.991,0,0,1-12.556-20.032c-5.852-10.2-11.392-20.564-17.316-31.316-10.481,4.5-19.254,2.024-27.454-3.886-.891-.642-2.328-.557-3.51-.808l-3.593-4c-8.61-11.737-16.894-23.723-25.943-35.125-5.923-7.463-13.4-13.429-23.3-15.508",
    transform: "translate(-166.719 -79.546)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M1332.276,1532.074q-.677-1.046-1.349-2.094c.215-.879.767-1.831.587-2.621-2.817-12.311-5.5-24.657-8.686-36.88-2.81-10.8-6.2-21.456-9.326-32.176,4.6-3.4,4.235-4.74-2.018-7.386q-3.219-7.277-6.44-14.553-.568-4.436-1.13-8.87c6.092-2.088,10.521,3.215,16.081,3.462a1.106,1.106,0,0,1,.809,1.179c-.1,4.794,2.513,7.22,7.151,7.877l.04.038,1.79,1.785.061.067,1.624,1.8q1,1.095,2.011,2.191l1.429,1.522.392.511a3.293,3.293,0,0,0,1.25,1.306l.495.128.123.487a3.314,3.314,0,0,0,1.139,1.187.728.728,0,0,1,.747.835,2.59,2.59,0,0,0,.662.7l8.725,9.273q.924.918,1.849,1.834l.011.011q.919.911,1.838,1.821.924.941,1.848,1.878l1.81,1.786.046.045,1.749,1.8.085.091,1.819,1.708.065.052,1.927,1.73q1.877,1.7,3.755,3.406l1.569,2.09q3.138,3.551,6.275,7.1c-4.1-.919-8.353-1.443-12.274-2.85-5.7-2.045-11.158-2.958-16.8-.092-3.171,1.609-6.415,3.082-10.134,4.86.6,1.308.839,3.038,1.851,3.87,9.487,7.816,15.281,18.42,22.491,27.975,6.886,9.124,14.44,17.765,21.7,26.617.262,3.386,2.021,5.285,5.575,5.4l.062.068c-.049,2.615-.115,5.241,3.638,5.385l.087.1q.884,1.755,1.765,3.512l.1.136,3.628,5.354.073.09,5.5,7.269,5.567,7.308c1.454,2.957,2.515,6.19,4.428,8.828,9.8,13.511,19.8,26.879,29.762,40.275,2.9,3.893,6.04,7.613,8.813,11.586,8.165,11.7,15.992,23.63,24.334,35.2,12.778,17.731,25.657,35.4,38.955,52.756,4.755,6.207,10.852,11.426,16.336,17.094l3.1,3.5c2.055,3.38,4.032,6.81,6.18,10.133,11.217,17.356,2.653,51.564-21.6,61.953-12.151,5.2-24.738,4.043-37.241,1.037-2.884-.693-5.7-1.66-8.875-2.6-.969,7.372-1.89,13.929-2.682,20.5-2.448,20.3-14.241,31.93-34.886,34.929-11.45,1.662-22.142-.524-32.488-4.968-5.932-2.548-11.6-5.694-17.514-8.284-1.751-.765-3.947-.558-5.939-.8-.254-5.747.232-11.645-.952-17.2-1.424-6.687-4.352-13.058-6.472-19.615-1.675-5.181-2.388-10.785-4.79-15.593-7.9-15.817-13.57-32.351-18.536-49.224-1.908-6.485-2.7-13.816-9.216-18.372-1.169-.816-1.07-3.331-1.629-5.039q-13.529-41.411-27.1-82.807c-.724-2.2-1.77-4.3-2.666-6.452a6.874,6.874,0,0,0-.7,5.382c8.277,26.249,16.774,52.433,24.948,78.712,12.049,38.732,23.7,77.584,35.985,116.244,1.983,6.242,2.922,13.88,10.683,16.95-2.525,15.147-15.688,18.119-27.345,21.937-5.95,1.95-11.835-.178-17.776-4.322-10.3-7.184-21.812-12.9-33.363-18.045-5.013-2.233-9.291-4.737-12.2-8.944-5.695-8.234-10.82-16.846-16.3-25.227a38.541,38.541,0,0,0-4.131-4.576c1.737-2.771,2.867-5.771-.359-8.039-2.915-2.049-3.312-4.659-3.658-7.8q-1.677-15.224-3.948-30.384c-2.241-14.841-4.782-29.639-7.105-44.469-2.65-16.911-5.094-33.852-7.833-50.75-2.017-12.443-5.533-24.778-1.624-37.472a8,8,0,0,0-.082-3.6c-1.5-8.272-3.208-16.51-4.568-24.8-1.653-10.075-3.03-20.193-4.525-30.294l22.243-1.633c7.919-.579,15.39-2.987,20.444-8.943a21.377,21.377,0,0,1,10.28-6.794,120.359,120.359,0,0,0,17.864-7.391c6.429-3.4,12.383-7.672,18.543-11.565,10.623-2.92,12.862-6.125,11.716-16.775q-.079-2.177-.157-4.354m23.5,97.4c3.164,6.866,5.177,12.254,8.007,17.19,10.082,17.586,20.5,34.984,30.682,52.515,17.384,29.931,34.621,59.943,52.057,89.843,4.736,8.122,9.868,16.029,15.075,23.87.785,1.18,2.981,1.457,5.434,2.561-.323-8.447-5.179-13.124-8.272-18.517q-19.228-33.535-38.8-66.879c-13.485-23.059-27.131-46.028-40.6-69.093-4.27-7.312-8.063-14.892-12.362-22.187a18.921,18.921,0,0,0-11.22-9.3m-54.366,6.859-.72,0v2.752l.72,0Zm1.988,7.616q-.214-.28-.427-.562l-.527.468.711.723c.081-.209.163-.418.244-.629",
    transform: "translate(-174.922 -160.171)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M857.442,988.383c-9.7-1.312-10.959-2.854-12.979-12.072-2.977-13.587-1.16-26.948,1.147-40.319,2.656-15.4,5.5-30.763,8.257-46.144a453.624,453.624,0,0,0,18.325-64.366c.479-2.31,1.392-4.532,2.07-6.8.6-2,1.808-4.077,1.609-6.006-1.146-11.087-2.066-22.243-4.125-33.183-3.388-18-12.8-32.491-28.29-43.061-7.571-5.166-16.148-7.293-24.992-8.832.274-6.884,1.639-13.321,7.606-17.874,3.485-3.994,9.062-6.233,11.173-12.665-5.043-.734-9.536-2.037-13.987-1.912-13.247.371-18.145-9.716-17.175-18.754,1.118-10.415,4.22-20.169,11.154-28.44,14.859-17.725,34.233-24,57-21.571,4.9.523,9.788,1.246,14.654,2.037,20.985,3.414,35.745,15.368,46.82,32.6,20.477,31.854,38.623,64.965,55.712,98.652,10.49,20.681,21.745,40.972,36.58,58.969,8.71,10.569,18.811,20.032,28.289,29.992-1.3,2.6-2,5.783-3.983,7.688-9.518,9.14-14.252,20.755-18,32.79-2.405,7.731-1.948,8.153-10.172,7.958-5.752-.136-10.354.887-12.953,6.506-.615,1.326-2.244,2.2-2.878,3.519-3.294,6.869-9.029,7.35-15.569,6.047-10.152-2.022-10.539-1.975-15.427,6.525-1.473,2.562-1.864,5.7-2.978,8.486-2.079,5.195-2.538,11.425-8.878,14.191-2.725-.861-5.3-2.08-8.005-2.452-7.914-1.092-16.136-2.913-22.922,3.174a81.653,81.653,0,0,0-10,10.674c-6.684,8.627-10.251,9.437-19.335,3.708-4.09-2.579-8.221-5.1-12.652-7.837-5.855,5.773-10.133,11.738-12.229,18.727-2.049,6.833-2.947,14-4.158,20.054Zm3.282-313.2a4.373,4.373,0,0,0,.681,1.423c-.37,5.4,2.721,7.954,7.6,9.454,5.857,1.8,11.213,1.36,16.2-2.267,3.741-2.027,6.9-4.513,7.417-9.073,2.394-9.523-1.094-17.063-9.561-20.664-8.252-3.51-14.581-1.009-20.519,8.11-2.831,4.041-4.216,8.275-1.812,13.017",
    transform: "translate(-144.762 -89.145)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M1060.743,1836.653c-4.919-3.065-9.981-3.235-15.808-2.419-16.24,2.276-32.115.388-46.829-7.26-21.38-11.111-31.488-29.086-32.452-52.411-.159-3.849-.022-7.709-.022-12.624-29.211,8.26-53.326,4.32-66.518-25.635q-.36-.811-.719-1.625l-1.357-3.462-.66-2.015q-1.417-8.208-2.835-16.416c2.247-2.086,1.1-3.173-1.2-3.923l-.491-.288c.087-.409.16-.82.217-1.235,1.728-11.726,7.946-21.35,15.19-30.374,3.427-4.269,7.92-7.719,11.308-12.012,11.295-14.314,22.329-28.828,33.425-43.293q22.476-29.3,44.856-58.668c1.038-1.363,2.512-3.651,2.013-4.7-3.842-8.051,1.248-11.691,7.139-15.178a43.23,43.23,0,0,0,6.006-4.179c4.362-3.714,9.011-7.226,12.754-11.487,4.355-4.96,7.92-10.594,11.728-16.005,4.3-6.115,10.22-11,11.643-19.177,1.334-7.664,6.7-10.169,14.581-8.634,1.8.352,3.553.973,5.327,1.47,2.342,8.149,4.737,16.272,11.3,22.362q3.671,1.537,7.349,3.084l9.191,3.735c3.618,12.936,4.37,13.684,14.648,14.544q3.15,12.695,6.3,25.389l-11.99-4.887c-.592.9-1.134,1.368-1.214,1.9-2.682,17.868-5.38,35.735-7.948,53.62-2.481,17.279-4.837,34.575-7.221,51.866-1.439,10.443-2.786,20.9-4.25,31.336-2.256,16.094-4.79,32.152-6.8,48.275-1.641,13.153-2.635,26.383-4.019,39.568-1.729,16.466-3.786,32.9-5.227,49.392-.473,5.42-2.094,9.349-7.409,11.36",
    transform: "translate(-150.851 -165.153)",
    fill: "#665a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M1451.807,545.863c-3.316.221-5.893-.423-7.278-4.013-3.976-10.3-12.931-16.633-20.6-23.9-4.156-3.937-9.279-6.887-13.478-10.788-1.75-1.627-2.23-4.57-3.289-6.915l.058.054a27.8,27.8,0,0,0,5-1.986c14.6-9.338,26.5-21.546,37.738-34.443l.014,0,1.843-1.81.013-.012,1.844-1.809,0-.016,3.712-3.642h.021l1.84-1.806.017-.015,1.843-1.809.013-.011,1.842-1.807.019-.017q.921-.9,1.844-1.811l.008-.005,1.854-1.82v0l1.864-1.831-.029.016q2.819-3.675,5.64-7.35c7.4-9.941,14.767-19.9,22.237-29.793a18.9,18.9,0,0,1,3.5-2.864c3.773-2.1,7.059-4.58,7.663-9.211l-.04.064q17.011-15.238,34.02-30.477c5.669-5.081,11.479-10.022,16.949-15.3,4.8-4.635,9.222-9.653,13.81-14.5l5.953,5.72A382.445,382.445,0,0,1,1540.3,383.69c-3.275,3.141-6.133,6.708-9.095,10.152-12.641,14.7-22.4,31.706-37.336,44.58-1.493,1.287-2.159,3.5-3.2,5.281-.6.626-1.2,1.249-1.8,1.876q-.914.908-1.837,1.808c-9.3,4.243-14.757,12.627-21.632,19.471-.517.514-.351,1.687-.5,2.553l-1.86,1.827-7.412,5.469-.437.745.381-.8,7.437-5.447,1.863-1.825q11.218-10.865,22.431-21.733.924-.9,1.854-1.792l1.9-1.771c3.151-2.317,6.554-4.369,9.413-6.991,21.663-19.855,42.94-40.121,64.9-59.652,16.661-14.818,34.088-28.811,51.326-43,2.748-2.262,6.291-3.594,9.467-5.357,5.53,4.506,11,9.146,19.048,7.554-3.713,4.387-7.165,9.021-11.179,13.124-19.141,19.557-38.434,38.972-57.676,58.434q-12.182,12.322-24.38,24.632c-8.93,7.355-17.93,14.63-26.773,22.083q-20.3,17.107-40.4,34.441c-3.854,3.327-7.341,7.064-10.991,10.617-9.855,5.225-18.753,11.616-25.747,20.328q-3.249,1.922-6.5,3.841.767.857,1.536,1.713l5.133-5.37L1474.4,500.64a36.711,36.711,0,0,0,4.778-2.575q30.5-22.6,60.9-45.323c6.059-4.547,11.818-9.479,17.714-14.233,4.588-3.044,9.365-5.849,13.726-9.179,10.938-8.353,21.552-17.116,32.546-25.4,13.2-9.943,26.993-19.145,39.928-29.4,25.291-20.049,52.98-36.47,80.769-52.787,2.814.652,5.608,1.743,8.447,1.875,7.855.366,15.73.332,23.595.451-9.27,9.505-18.439,19.11-27.834,28.5-7.435,7.427-15.146,14.586-22.735,21.864-1.612.829-3.486,1.373-4.794,2.532-8.708,7.711-17.207,15.648-25.941,23.329-11.482,10.1-22.381,21.029-34.838,29.82-25.755,18.173-51.906,35.9-78.765,52.45-28.735,17.708-58.466,33.861-87.776,50.672-7.412,4.251-14.873,8.421-22.311,12.628",
    transform: "translate(-187.388 -62.181)",
    fill: "#eae4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M860.8,1010.052h18.71c1.211-6.057,2.11-13.221,4.158-20.053,2.1-6.99,6.374-12.955,12.229-18.728,4.431,2.743,8.561,5.258,12.651,7.838,9.085,5.729,12.652,4.92,19.335-3.707a81.63,81.63,0,0,1,10-10.674c6.785-6.088,15.008-4.267,22.922-3.175,2.7.373,5.28,1.592,8.005,2.452,6.341-2.766,6.8-9,8.879-14.189,1.114-2.787,1.505-5.925,2.978-8.486,4.888-8.5,5.275-8.548,15.427-6.525,6.54,1.3,12.275.821,15.569-6.047.634-1.324,2.263-2.193,2.878-3.52,2.6-5.62,7.2-6.641,12.953-6.505,8.224.194,7.766-.227,10.172-7.958,3.744-12.036,8.478-23.651,18-32.791,1.984-1.906,2.689-5.092,3.983-7.688,13.109,9.227,27.127,16.693,42.672,21.2l-5.262,12.792c-11.056,37.816-27.824,73.2-47.655,107.258-2.9,4.979-6.691,9.454-10.019,14.2-4.155,5.927-9.12,10.338-16.908,11.415-7.617,1.054-11.887,7.231-16.7,12.306-2.1,2.211-3.589,4.977-5.712,7.158-5.17,5.31-11.2,8.817-18.98,6.1-4.414-1.546-7.892-.009-11.25,2.28-15.114,10.3-30.566,9.232-46.466,1.854a28.878,28.878,0,0,0-10.623-2.4c-12.159-.543-23.4-2.284-33.9-9.833-7.7-5.533-16.34-9.655-22.112-17.514-4.409-6-4.506-6.635-.608-12.915,1.77-2.85,3.948-5.525,5.226-8.568.641-1.524-.32-3.7-.556-5.575",
    transform: "translate(-148.119 -110.814)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M1226.476,1602.616c1.5,10.1,2.872,20.218,4.525,30.292,1.361,8.293,3.072,16.531,4.569,24.8a7.989,7.989,0,0,1,.081,3.6c-3.91,12.694-.394,25.029,1.623,37.474,2.739,16.9,5.182,33.839,7.832,50.75,2.323,14.829,4.865,29.627,7.107,44.468q2.287,15.147,3.949,30.384c.347,3.144.742,5.753,3.658,7.8,3.227,2.269,2.1,5.268.36,8.039-3.073,5.821-6.334,11.556-9.174,17.485-3.654,7.625-6.374,15.733-10.555,23.051-9.6,16.8-22.288,19.289-38.306,15.822-14.67-3.176-26.889-10.444-33.185-24.862-1.08-2.473-2.032-5.211-5.589-5.165,1.2-11.367-1.567-22.564-.381-34.138,2.031-19.8.55-39.822,1.789-59.811,1.586-25.584,2.1-51.246,3.93-76.866,1.66-23.205,1.382-46.541,2.139-69.813.372-11.453,1.328-22.889,1.626-34.342.083-3.185-1.241-6.406-1.919-9.61l3.624-7.361c2.771,2.445,4.7,4.324,6.815,5.981,11.48,9.011,22.848,18.248,38.154,20.376l7.329,1.64",
    transform: "translate(-170.054 -173.258)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M1164.24,1580.311c.678,3.2,2,6.425,1.918,9.61-.3,11.453-1.254,22.889-1.626,34.342-.756,23.272-.479,46.608-2.139,69.813-1.833,25.62-2.344,51.28-3.931,76.865-1.239,19.99.243,40.008-1.788,59.811-1.187,11.574,1.581,22.771.381,34.138-14.555,9.358-30.176,12.853-47.488,9.29-13.659-2.813-23.311-10.356-30.141-21.944-1.831-3.107-3.859-6.1-5.8-9.151,5.317-2.01,6.937-5.938,7.41-11.359,1.441-16.489,3.5-32.926,5.227-49.392,1.384-13.186,2.378-26.415,4.02-39.569,2.012-16.122,4.547-32.181,6.8-48.275,1.463-10.439,2.81-20.893,4.249-31.336,2.384-17.291,4.74-34.586,7.221-51.865,2.569-17.886,5.266-35.753,7.948-53.621.08-.534.623-1,1.214-1.9l11.988,4.887c2.4,5.184,4.318,10.662,7.318,15.491,7.151,11.516,17.35,12.9,27.211,4.167",
    transform: "translate(-163.74 -171.586)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M1388.222,722.571l-15.8-27.781c9.8-2.482,18.335-4.528,26.792-6.848a34.828,34.828,0,0,0,9.126-3.67c4.6-2.858,4.895-5.092,2.248-9.747a6.933,6.933,0,0,0-.561-.72c-9.573-12.6-4.633-13.268,5.894-17.877,2.444-1.069,5.061-1.755,7.6-2.617l46.318-3.636c1.7,1.988,3.15,4.271,5.147,5.91,6.794,5.576,11.191,12.083,9.791,21.235-7.962.658-15.916,1.42-23.887,1.946-7.674.506-15.51,0-23.008,1.355s-15.535-1.543-22.624,3.073c8.82,1.646,17.622,2.436,26.426,3.21,12.838,1.128,25.68,3.207,38.518,3.188,41.656-.061,83.335,1.5,124.97-1.53,15.957-1.162,31.993-1.272,47.992-1.88s32-1.687,48-1.739a423.447,423.447,0,0,0,52.391-3.9c6.949-.889,13.822-2.364,20.73-3.573-.049,3.269,1.923,4.756,4.867,5.616,3.8,1.109,7.6,2.257,11.294,3.674,10.422,4,14.459,9.729,13.718,20.678-.528,7.8-2.2,15.43-10.556,19.312a40.163,40.163,0,0,0-6.446.377c-12,2.616-23.88,5.892-35.979,7.933A148.658,148.658,0,0,1,1722.7,736.8c-12.886-.344-25.723-2.2-38.6-3.188q-26.24-2.014-52.508-3.677-30.894-1.955-61.81-3.6c-14.471-.765-28.951-1.57-43.436-1.817-46.038-.785-92.081-1.316-138.122-1.945",
    transform: "translate(-184.925 -91.254)",
    fill: "#c8c4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M1461.261,565.427q-.936-4.348-1.873-8.7c4.542-1.835,9.281-3.306,13.591-5.566,17.136-8.983,34.242-18.031,51.162-27.4,17.18-9.508,34.484-18.873,51.111-29.261,43.937-27.448,87.549-55.4,131.255-83.2,5.642-3.59,11.072-7.5,16.6-11.262q18.622-9.833,37.243-19.666,31.659-16.731,63.3-33.488c4.264-2.266,8.381-4.8,12.567-7.205,1.64.432,3.462,1.548,4.887,1.181a191.21,191.21,0,0,0,19.395-5.8c19.255-7.217,38.791-13.425,59.178-16.7,1.806-.291,3.86.9,5.8,1.409-.912,1.2-1.726,2.494-2.75,3.6-24.28,26.161-53.491,46.656-83.529,65.392-40.506,25.264-82.636,48.051-124.365,71.392-27.569,15.42-55.668,29.927-83.493,44.908a39.167,39.167,0,0,0-5.023,3.808c-7.857,3.371-15.669,6.854-23.585,10.089-20.748,8.478-41.131,18.069-62.42,24.949-25.945,8.384-52.667,14.452-79.053,21.521",
    transform: "translate(-191.091 -61.877)",
    fill: "#eae4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M1387.748,1552.962c-7.26-8.853-14.814-17.491-21.7-26.617-7.21-9.555-13-20.159-22.492-27.974-1.012-.833-1.254-2.563-1.851-3.871,3.72-1.777,6.964-3.25,10.134-4.86,5.644-2.864,11.1-1.952,16.8.093,3.921,1.407,8.17,1.931,12.275,2.851l5.077,4.2,1.708,1.492.083.085,1.658,1.768.161.185,1.6,1.659.241.261,1.567,1.569.287.282,1.537,1.542.317.346q.75.738,1.5,1.477l.364.314q.75.75,1.5,1.5l.348.42q.69.705,1.381,1.411l.4.4c.323,5.041,2.531,8.32,8.163,8.4l3.349,3.406c.989,9.069,1.623,9.733,10.868,11.408l.073.068,1.774,1.744.083.082q.872.876,1.75,1.75l.1.1,1.715,1.738.126.142q.86.84,1.722,1.682l.14.121,1.762,1.695.1.1,1.762,1.714,1.978,1.887,1.824,1.724.052.054q.941.873,1.887,1.748c6.566,5.929,13.266,11.722,19.676,17.81,31.949,30.338,64.083,60.5,95.607,91.255,14.206,13.86,27.155,28.96,40.641,43.525a33.779,33.779,0,0,1,2.691,3.684c11.152,15.958,8.233,37.045-7.032,49.517-8.7,7.111-19.066,6.259-29.173,4.639-5.08-.815-9.888-3.27-14.818-4.983l-2.244-1.171-5.725,1.5-3.1-3.5c-1.038-3.1-1.562-6.5-3.215-9.245-4.374-7.268-9.27-14.232-13.9-21.355-2.979-4.587-5.491-9.513-8.836-13.821-15.095-19.437-30.543-38.612-45.614-58.067-15.26-19.7-30.184-39.652-45.4-59.383-1.32-1.712-3.75-2.6-5.664-3.871l-5.567-7.308c.236-3.93-.612-7.071-5.5-7.268l-.073-.09c.073-2.62.191-5.271-3.629-5.354l-.1-.136-1.766-3.512-.088-.1q-1.819-2.691-3.639-5.385l-.061-.068c-.111-3.535-1.979-5.326-5.576-5.4",
    transform: "translate(-182.747 -165.563)",
    fill: "#665a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M1387.238,771.476l24.185,0a87.75,87.75,0,0,0,9.04,1.758c29.149,2.672,57.29,10.582,85.939,15.839,14.174,2.6,28.311,5.4,42.464,8.113,3.158.911,6.279,1.976,9.478,2.709,26.567,6.1,53.041,12.648,79.77,17.969,13.748,2.738,27.925,3.72,41.966,4.621,11.369.729,22.826.241,34.241.094a40.994,40.994,0,0,0,9.984-1.249c9.125-2.443,18.155-5.221,27.222-7.868-6.226,21.348-22.083,34.231-40.789,43.817.706,6.434,1.456,12.053,1.915,17.7.945,11.629-4.468,20.611-13.274,27.55-5.482,4.32-11.9,7.48-17.79,11.328-1.154.755-1.789,2.274-2.665,3.441-1.694,6.166-6.035,3.711-9.615,2.614-20.95-6.42-40.545-15.909-59.107-27.168-15.091-9.153-29.347-19.645-43.819-29.753-2.027-1.416-3.182-4.033-4.74-6.095-1.422-2.246-2.5-4.807-4.319-6.685-10.366-10.707-23.346-17.759-36.825-23.707q-39.15-17.275-78.762-33.534c-15.582-6.4-31.574-11.828-47.341-17.8a67.939,67.939,0,0,1-7.158-3.691",
    transform: "translate(-185.975 -102.053)",
    fill: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M1492.212,669.731c1.4-9.151-3-15.659-9.792-21.235-2-1.639-3.446-3.921-5.146-5.909,8.127-1.536,16.287-2.921,24.375-4.638,20.693-4.394,41.338-9.009,62.031-13.4,35.99-7.64,72.075-14.868,107.986-22.85,32.646-7.257,65.314-14.531,97.2-24.7,1.781-.264,3.579-.45,5.341-.806q15.9-3.2,31.79-6.469c6,.615,12.023,1.091,18,1.872q19.829,2.588,39.619,5.452c3.854.555,4.812,2.435,1.865,5.423l-1.883,1.911.092-.077q-4.484,5.092-8.965,10.184c-9.552,10.909-18.021,22.954-34.513,25.061-5.66.724-10.979,3.9-16.5,5.831-4.36,1.523-8.728,3.081-13.2,4.22-14.3,3.644-28.533,7.635-42.995,10.506-24.4,4.844-48.892,9.339-73.473,13.2-16.979,2.663-34.163,4.1-51.275,5.906-17.723,1.876-35.456,3.675-53.209,5.249-10.427.925-20.9,1.293-31.351,2.005-15.339,1.045-30.672,2.174-46.006,3.268",
    transform: "translate(-192.359 -84.166)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M1638.381,964.49c1.326,7.1,3.185,14,2.033,21.486-1.892,12.32-9.046,20.221-19.85,25.6-3.27,1.629-6.665,3.015-9.944,4.485-.52,3.125-1.085,5.779-1.388,8.462-1.882,16.625-12.665,27.129-25.834,35.843a26.315,26.315,0,0,1-17.667,4.248c-1.227-.023-2.456-.03-3.685-.071-8.812-.3-9.029-.547-9.453-9.391a45.369,45.369,0,0,0-11.11-27.988c-3.338-3.911-6.834-7.759-5.614-13.5-.117-4.087-.239-8.173-5.578-9.224l0,0c-2.765-6.579-5.022-13.429-8.458-19.651-2.683-4.859-6.833-8.939-10.331-13.366-6.616-10.755-12.425-21.972-22.338-30.548-4.4-3.81-8.465-6.722-14.5-5.8q-.075-.85-.11-1.7l29.491-1.811c3.694-.228,6.109-2.243,5.652-5.767a34.673,34.673,0,0,0-3.3-10.966c-1.463-2.906-4.172-5.2-6.271-7.8a230,230,0,0,0-47.183-44.552c-11.263-7.9-21.891-16.686-32.59-25.328-2.781-2.246-4.763-5.446-7.11-8.208,3.164,1.156,6.354,2.249,9.487,3.48,14.6,5.731,29.073,11.805,43.814,17.171,16.155,5.88,32.551,11.118,48.843,16.636,4.647,8.177,11.054,14.727,18.443,20.663,19.419,15.6,38.141,32.062,57.9,47.234,14.682,11.277,29.512,22.613,46.661,30.371",
    transform: "translate(-187.818 -107.147)",
    fill: "#888a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M1889.41,493.943c-4.568,7.664-11.467,12.988-18.729,17.946-3.065-3.5-5.733-.374-8.176.766-26.3,12.269-53.783,21.236-81.8,28.815-9.141,2.473-18.072,5.695-27.1,8.575-15.489,3.7-31.061,7.1-46.449,11.17-29.037,7.679-57.969,15.743-86.945,23.647-4.684-5.515-7.755-4.954-11.125,2.034l-14.755,3.62c-9.1-8.417-14.881-18.183-13.115-31.02,2-.758,4-1.488,5.985-2.279q26.746-10.669,53.484-21.358c4.123-1.167,8.4-1.965,12.346-3.562,33.95-13.74,67.921-27.438,101.723-41.524,28.939-12.06,57.662-24.614,86.481-36.949,1.331.6,2.634,1.645,4,1.726,12.148.723,24.337.938,36.452,1.991,8.345.725,17.051.529,24.562,5.274-.872,1.856-1.822,3.68-2.6,5.573-2.245,5.463-4.421,10.954-6.625,16.434l.019,0-3.725,3.658,0-.039-1.913,3.665.041-.061-2.031,1.895",
    transform: "translate(-199.706 -73.891)",
    fill: "#e8e1d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M1064.06,1479.8c-1.774-.5-3.524-1.118-5.327-1.47-7.877-1.535-13.247.97-14.58,8.634-1.423,8.182-7.342,13.063-11.643,19.177-3.808,5.411-7.373,11.046-11.728,16-3.742,4.263-8.392,7.774-12.754,11.488a43.173,43.173,0,0,1-6.006,4.178c-5.891,3.488-10.981,7.128-7.139,15.178.5,1.045-.976,3.333-2.014,4.7q-22.353,29.388-44.856,58.668c-11.1,14.465-22.13,28.979-33.425,43.293-3.388,4.293-7.881,7.744-11.308,12.012-7.244,9.025-13.462,18.649-15.2,30.375l-15.348-.142-3.669-.318-5.475-1.432-13.029-6.667c-1.445-7.009-2.772-14.046-4.448-21-.281-1.165-1.967-2.155-3.2-2.915-2.317-1.424-4.779-2.621-7.181-3.912q.515-3.768,1.029-7.535a2.349,2.349,0,0,0,.779-1.35l.114-.218,1.542-2.04-.063.073,1.9-1.952-.094.061c4.658.2,5.815-2.7,5.977-6.485q.99-1.2,1.977-2.4l1.59-1.745.086-.107,1.686-1.918-.017.016q5.755-.193,5.452-5.834.686-.793,1.367-1.584a2.349,2.349,0,0,0,.768-.9q1.031-1.255,2.062-2.51l1.61-1.691.141-.139,1.7-1.737.1-.1,1.713-1.838.024-.024,1.773-1.938-.049.044c3.376.148,3.953-1.982,3.909-4.619l2.341-2.64,1.368-1.437,3.774-3.95,1.742-1.783,1.78-1.91,1.859-1.963q1.7-1.878,3.394-3.754s.438-.466.438-.466a.986.986,0,0,1,.9-1.014,3.828,3.828,0,0,0,1.006-1.093q-.057-.692.649-.7l1.224-1.393.33-.422,1.483-1.567,2.051-2.125,1.61-1.754q3.335-3.779,6.666-7.557a2.306,2.306,0,0,0,.832-.842.675.675,0,0,1,.759-.747,3.423,3.423,0,0,0,1.082-1.113l2.281-2.536,1.461-1.453.358-.351,1.486-1.595.191-.25,1.628-1.716.13-.129,1.685-1.819.033-.038q7.311-1.024,7.459-8.267l2.492-2.757q.626-.657,1.254-1.314l.241-.294c4.054.2,5.661-1.785,5.211-5.61l3.506-4.018s.2-.194.2-.194a1.416,1.416,0,0,1,1.179-1.239l.452-.455q1.677-1.688,3.349-3.376s.436-.432.436-.432l2.483-3.077,1.464-1.584.123-.147q.839-.915,1.679-1.834l.031-.035,1.78-1.887-.019.015c2.7-.028,3.814-1.431,3.608-3.986q1.5-1.685,2.994-3.369a2.212,2.212,0,0,0,1-1.037l.107-.462.47-.106a3.06,3.06,0,0,0,1.256-1.278l2.284-2.388,1.448-1.484.272-.328q.777-.817,1.554-1.637l.194-.207,1.643-1.629,3.791-3.876q.85-.953,1.7-1.906.807-1.053,1.613-2.1l0-.009q1.673-1.742,3.342-3.483a2.463,2.463,0,0,0,.761-.894l.072-.481.469-.156,1.289-1.32,2.167-2.357,1.537-1.6.2-.219,1.624-1.7.148-.146,1.678-1.781.057-.064c3.29-.008,3.723-2.264,3.876-4.742l.095-.495.484-.165a3.313,3.313,0,0,0,1.142-1.144q-.021-.694.686-.673a3.225,3.225,0,0,0,1.153-1.163q1.038-1.257,2.074-2.515l1.594-1.721,3.081-3.687c4.043-.145,6.334-1.91,5.925-6.171l2.35-3,1.638-1.783.058-.07,1.754-1.876c10.831-13.577,21.754-27.073,35.3-38.239l9.517-1.773q1.707,4.468,3.421,8.938c-.883,3.46,1.613,5.256,3.712,7.247-.521,2.881-1.428,5.755-1.494,8.647-.24,10.542-.2,21.091-.265,31.637",
    transform: "translate(-146.872 -159.844)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M620.763,833.85q2.394,2.413,4.781,4.826c-.931,1.443-2.963,3.306-2.588,4.248,1.6,4.03,3.912,7.789,6.125,11.951-7.433,9.587-15.792,19.287-22.907,29.8-10.463,15.456-24.064,27.089-40.271,36.372-8.369,4.794-17.625,8.919-21.8,18.842-.722,1.717-4.523,2.188-6.9,3.234-13.405-1.146-26.079-4.654-37.08-12.424-11.166-7.887-17.89-18.854-20.953-31.656-8.425-2.4-16.673-4.7-24.891-7.107-18.1-5.292-24.876-19.392-28.525-35.75-.555-2.489-.027-5.21,0-7.824,18.129-.807,36.229.742,54.447-1.408,20.278-2.393,39.8-7.115,59.15-13.035,2.5-.764,4.662-2.564,6.984-3.883l.124.042c4.241-1.092,8.568-1.948,12.679-3.394,1.585-.557,2.681-2.453,4-3.739,5.5-4.564,15.415-8.344,19.766-7.536a6.606,6.606,0,0,1-.212,1.752c-4.564,11.154-2.209,14.589,10.309,14.821,4.928.092,9.86-.005,14.789-.016l-5.982,8.465c2.388.75,4.031,1.839,5.462,1.616a21.391,21.391,0,0,0,13.49-8.193m-40.846,21.792,1.854-1.82a2.582,2.582,0,0,0,.631-.288c.1-.085.095-.3.137-.458l-.744.77-1.856,1.817a2.6,2.6,0,0,0-.637.267c-.106.081-.107.3-.155.451q.386-.369.771-.739m-18.623,12.685a29.418,29.418,0,0,0-11.856,5.634l1.285,1.989q5.353-3.735,10.705-7.471l3.689-1.828c4.235-1.05,8.524-2.033,9.265-7.332a2.526,2.526,0,0,0,.658-.293c.11-.092.1-.326.141-.5l-.846.742c-4.206,1.052-8.561,1.917-9.353,7.224l-3.688,1.83m-52.18,21.714c16.5-1.578,25.045-4.68,30.5-10.462l-30.5,10.462",
    transform: "translate(-117.786 -105.938)",
    fill: "#888a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M1563.025,415.1q12.19-12.315,24.379-24.631c19.242-19.462,38.534-38.877,57.676-58.434,4.015-4.1,7.466-8.736,11.179-13.122,7.335-6.5,14.745-12.919,21.984-19.521,12-10.943,23.752-22.143,35.846-32.98q27.021-24.215,54.38-48.067c23.313-20.421,44.754-42.622,65.506-65.509,8.83-9.738,18.078-19.114,27.258-28.54,1.111-1.14,2.988-1.563,5.033-2.579.591,1.763,1.324,2.857,1.253,3.9-2.472,35.82-16.4,67.33-37.472,96.228-13.268,18.2-31.022,31.892-47.31,47.147-10.578,9.906-21.522,18.928-33.807,26.544-4.425,2.744-8.748,5.648-13.12,8.478-27.79,16.317-55.479,32.737-80.77,52.786-12.935,10.254-26.73,19.457-39.929,29.4-10.993,8.281-21.607,17.044-32.545,25.4-4.36,3.329-9.138,6.133-13.725,9.176.423-4.221-1.718-5.911-5.816-5.67",
    transform: "translate(-198.439 -44.447)",
    fill: "#c4bfb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M1534.441,1020.3c-1.221,5.736,2.276,9.583,5.613,13.495a45.378,45.378,0,0,1,11.111,27.989c.425,8.843.64,9.093,9.453,9.39,1.227.042,2.457.048,3.685.071-1.52,2.916-3.525,5.689-4.48,8.773-5.532,17.866-19.728,26.958-35.661,34.312a66.184,66.184,0,0,1-7.868,2.537c-2.776-2.215-5.82-4.181-8.259-6.709-2.931-3.037-5.092-6.791-8.037-9.813-6.823-7-14.457-13.307-20.774-20.705-9.847-11.531-19.549-23.29-28.09-35.759-12.5-18.255-23.881-37.246-35.818-55.875-7.332-11.443-14.809-22.8-22.221-34.191,2.771-10.221,4.466-20.383,2.428-31.12-1.165-6.137-.271-12.65-.3-18.993,5.809,5.375,11.675,10.694,17.416,16.141q18.25,17.318,36.4,34.74c7.075,6.678,14.4,13.125,21.171,20.088,11.913,12.247,26.485,17.137,43.407,16.232a34.174,34.174,0,0,1,4.3,4.222c3.762,5.242,7.323,10.623,10.961,15.949l0,0,5.578,9.224m-29.7,23.552-1.846-1.832-3.631-3.708q-.451-4.976-5.518-5.533l-3.785-5.383q-1.856-1.831-3.714-3.66c.01-2.635-.107-5.188-3.705-5.473.111-3.093-.525-5.813-3.761-7.232-2.041-6.461-4.779-12.539-9.963-17.286,1.982,6.493,2.807,13.608,9.873,17.361-.2,3.132.5,5.829,3.685,7.318q1.862,2.728,3.725,5.456,1.844,1.835,3.69,3.664,1.839,2.739,3.674,5.48c.393,3.272,2.133,5.218,5.6,5.467l3.812,3.551,1.867,1.81,1.86,1.817a2.461,2.461,0,0,0,.287.615c.085.1.305.1.465.138l-.761-.745-1.854-1.825m-42.7-63.783a2.507,2.507,0,0,0-.317-.635c-.094-.1-.325-.092-.494-.132q.386.4.774.8l1.827,3.664c.4,2.262-.9,5.485,5.166,5.908-2.294-2.717-3.677-4.357-5.063-5.994q-.946-1.807-1.894-3.614m-2.3-5.549-.438-.585q-.269.243-.54.485l.731.751.246-.651",
    transform: "translate(-186.391 -113.776)",
    fill: "#8f9193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M1069.01,1407.719l-9.519,1.772c-.2-.863-.1-2.151-.654-2.527q-19.352-13.233-38.828-26.277c-1.146-6.007,6.747-6.483,7.709-12.726l-12.136-2.581c-1.976-4.465,1.7-10.508-3.077-15.7-1.149,4.043-2.086,7.344-3.023,10.645-2.591-6.129-6.37-10.923-13.7-11.732L985.262,1327.5c-3.012-12.7-4.652-25.534-3.682-38.572a133.46,133.46,0,0,1,2.187-16.094c.7-3.512,2.654-5.812,7.188-5.121,13.576,2.072,19.148-1.8,22.09-14.854.324-1.439.545-2.9.911-4.867,12.124-.805,23.99-1.905,35.52,2.719,13.953,5.6,23.146,15.912,28.641,29.21a312.671,312.671,0,0,1,12.993,36.7c4.287,15.676,12.122,29.6,19.645,43.767,1.231,2.319,1.809,4.971,2.688,7.469l-7.946,11.051-8.994,8.362-.245.246-1.683,1.663-.082.076q-.929.891-1.856,1.784l.035-.047-2.01,1.945.039-.318c-1.544.948-3.149,1.813-4.622,2.858-5.712,4.048-11.383,8.152-17.069,12.236",
    transform: "translate(-157.193 -144.236)",
    fill: "#c4bfb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M1219.273,1069.864c1.184.251,2.62.166,3.511.808,8.2,5.91,16.973,8.387,27.454,3.886,5.924,10.751,11.463,21.119,17.316,31.316a221.787,221.787,0,0,0,12.555,20.032c4.146,5.709,9.471,10.325,16.919,11.883,7.068,1.478,10.352-.588,9.656-7.566-.527-5.286-2.547-10.453-4.151-15.6-.577-1.85-1.88-3.482-1.425-6.192l6.668,8.984c3.817,5.144,7.476,6.292,13.41,4.209,5.23-1.836,7.981-6.368,7.321-12.161-.339-2.984-.768-5.958-1.158-8.936l7.145-3.7c3.159,4.063,4.827,8.363,1.709,13.155-2.491,3.831-1.316,6.793,1.893,9.477,2.561,2.144,4.976,4.464,7.616,6.508,5.441,4.215,12.238,7.379,16.248,12.617,10.22,13.349,19.715,27.3,26.6,42.736a6.436,6.436,0,0,0,2.137,2.657c8.164,5.416,11.049,14.542,16.249,22.035-1.559,6.451-2.4,13.175-4.831,19.3-4.554,11.49-13.994,14.974-25.648,10.269-3.094-1.248-6.038-2.853-9.927-4.713-2.1,3.719-4.031,7.041-5.855,10.419-1.295,2.4-2.166,5.062-3.713,7.279-3.948,5.66-5.957,6.148-12.4,3.467-3.7-1.539-7.224-3.558-11.02-4.784-4.6-1.484-9.407-2.358-14.124-3.5,1.073-4.774-3.462-6.729-5.28-10.044-10.469-19.089-22.095-37.658-31.247-57.333-11.01-23.668-25.183-45.364-39.061-67.322-8.237-13.032-16.381-26.12-24.568-39.182",
    transform: "translate(-174.066 -128.507)",
    fill: "#888a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M545.727,945.394c2.379-1.046,6.179-1.516,6.9-3.232,4.174-9.924,13.429-14.049,21.8-18.843,16.207-9.282,29.808-20.917,40.27-36.371,7.116-10.51,15.474-20.211,22.908-29.8-2.214-4.163-4.525-7.921-6.125-11.951-.375-.943,1.657-2.806,2.589-4.248q11.676,6.6,23.336,13.2c2.777,15.013,8.25,28.878,17.732,41.141,2.388,3.088,4.124,6.661,6.161,10.011-2.8,9.755-5.724,19.478-8.38,29.271-7.785,28.721-16,57.33-22.133,86.472-1.116,5.307-.669,11.541-5.615,15.68-9.692-3.92-18.737-8.621-26.241-16.2-7.989-8.066-14.066-16.694-13.815-28.9l-7.228-1.348c8.105-.539,13.445-4.968,17.144-11.715.142-.259.461-.42.616-.675,8.833-14.517,18.433-28.652,26.222-43.69,5.671-10.951,8.992-23.079,13.258-34.718a70.078,70.078,0,0,0,1.836-7.214c-2.032.415-2.855,1.26-3.319,2.264-7.761,16.8-15.157,33.784-26.618,48.655-6.485,8.414-12.288,17.387-22.272,22.514-2.125,1.091-3.643,3.259-5.636,4.665-6.442,4.548-13.019,8.914-19.433,13.5-1.081.771-1.612,2.284-2.4,3.453-14.4-6.395-24.022-16.744-27.921-32a99.883,99.883,0,0,0-3.638-9.925",
    transform: "translate(-126.31 -108.213)",
    fill: "#8f9193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M1415.74,1201.72c-5.2-7.491-8.085-16.618-16.25-22.034a6.421,6.421,0,0,1-2.136-2.657c-6.886-15.432-16.38-29.386-26.6-42.736-4.011-5.238-10.808-8.4-16.249-12.618-2.64-2.044-5.055-4.364-7.616-6.507-3.209-2.685-4.384-5.647-1.893-9.478,3.118-4.793,1.45-9.093-1.708-13.155,2.206-2.691,7.779-1.968,7.532-7.147,7.089,1.08,11.195-2.41,12.559-8.768,1.185-5.519,1.462-11.225,2.142-16.848l10.272-.368c-5.02-7.719-8.9-13.946-13.1-19.957-1.068-1.529-3.159-2.37-4.779-3.526,1.081-4.224,2.162-8.449,3.207-12.533,5.2,2.191,10.729,5.65,16.7,6.736,6.764,1.229,12.115-2.728,15.574-8.65,3.17,2.21,7.523,3.749,9.293,6.753,5.982,10.151,12.328,20.386,16.2,31.38,8.422,23.9,15.44,48.273,22.953,72.476a69.093,69.093,0,0,0,16.705,28.617c2.668,2.7,6.3,4.487,9.487,6.691-.35,1.929-1.075,3.874-.987,5.784.509,11.109-2.761,20.347-13.175,26.029a137.048,137.048,0,0,1-13.274,6.361c-9.025,3.729-17.483,3.062-24.866-3.846m-38.931-138.368-.858-.385.769.473c.277,4.4.866,8.614,7.5,9.081q-3.7-4.585-7.411-9.169m11.159,16.39-2.305-2.746q-.3.3-.6.592l2.793,2.266c.4,5.46,1.964,10.124,9.547,12.752-2.745-5.905-4.739-10.281-9.436-12.864m11.081,15.175c1.1,8.106,13.246,23.274,20.933,26.307-7.147-9.849-12.989-18.822-20.933-26.307",
    transform: "translate(-182.859 -124.217)",
    fill: "#838789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M1845.356,441.952c-28.819,12.336-57.543,24.89-86.482,36.949-33.8,14.087-67.772,27.783-101.722,41.524-3.943,1.6-8.222,2.393-12.346,3.56,1.241-6.16-2.242-10.574-5.749-14.979a39.6,39.6,0,0,1,5.024-3.8c27.825-14.981,55.924-29.488,83.493-44.908,41.729-23.34,83.859-46.128,124.365-71.392,30.04-18.735,59.25-39.231,83.529-65.392,1.024-1.1,1.839-2.393,2.75-3.6.232,1.854,1.116,3.907.6,5.532-11.584,36.475-30.4,68.648-60.347,93.594-10.254,8.543-22.033,15.325-33.115,22.912",
    transform: "translate(-203.829 -62.019)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M476.6,676.159c-2.758,3.505-6.167,4.281-10.532,3.1-3.18-.86-6.6-.869-9.913-1.258l-8.117-2.9c-3.4-10.929-12.561-16.267-21.6-21.71-2.523-1.519-5.109-2.935-7.663-4.4-29.1-13.675-58.088-27.584-87.354-40.909-11.939-5.436-24.476-9.606-36.741-14.352-6.429-3.447-12.745-7.119-19.308-10.3-22.079-10.715-44.6-20.6-66.279-32.044a418.471,418.471,0,0,1-64.267-42.407c-12.9-10.216-25.632-20.64-38.52-30.874a60.234,60.234,0,0,0-6.854-4.134l.117.079-1.664-1.852c-3.046-2.542-4.555-5.58-2.96-10.6,2.1.208,4.729-.228,6.518.775a128.277,128.277,0,0,1,16.156,10.312c21.151,16.444,40.818,34.9,64.517,47.906a328.813,328.813,0,0,0,43.358,20.2c24.433,9.077,49.41,16.746,74.184,24.935a43.125,43.125,0,0,0,6.289,1.113q3.566.949,7.137,1.9l5.53,3.673a12.433,12.433,0,0,0,2.244,2.834c12.053,8.369,23.944,16.993,36.338,24.851,8.391,5.32,17.51,9.535,26.3,14.244.067-2.464-.717-3.685-1.836-4.406-14.408-9.3-28.747-18.7-43.359-27.678-6.208-3.815-13.011-6.7-19.545-10q-2.794-1.8-5.587-3.612c-1.8-5.363-6.765-5.968-11.292-7.232l.115.089-1.9-1.831c-3.649-3.63-6.99-7.633-11-10.822-12.676-10.077-26.4-19.011-38.265-29.914-24.305-22.341-48.633-44.823-65.664-73.521-6.376-10.743-12.987-21.291-15.568-33.735-.513-2.473-2.408-4.67-3.666-6.994-2.09-3.905-2.982-7.622,1.527-10.956.98.888,1.863,1.344,2.213,2.053a432.6,432.6,0,0,0,36.319,60.767,136.164,136.164,0,0,0,15.057,17.13c17.136,16.944,33.7,34.448,53.837,48.286,11.3,7.768,21.337,17.284,32.415,25.391,10.341,7.567,21.5,14.047,31.952,21.48,14.891,10.592,30.864,19.8,43.82,32.91,9.247,9.354,18.788,18.428,28.12,27.7,17.675,17.565,37.966,31.607,60.076,43.24,1.866.982,3.544,2.31,5.31,3.478",
    transform: "translate(-94.304 -68.562)",
    fill: "#ede8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M1855.341,330.431c-4.185,2.409-8.3,4.94-12.567,7.205q-31.619,16.8-63.3,33.488-18.618,9.838-37.244,19.664c-.647-3.78-1.7-7.546-1.831-11.343-.147-4.065-2.035-6.525-5.252-8.733-2.294-1.574-4.077-3.864-6.088-5.834,7.589-7.278,15.3-14.437,22.735-21.864,9.395-9.387,18.564-18.991,27.834-28.5,5.719-3.531,11.577-6.866,17.127-10.637,17.234-11.71,34.5-23.381,51.476-35.446,22.733-16.155,45.193-32.679,67.8-49,2.638-1.9,5.484-3.53,8.528-5.471,3.167,6.972.184,12.821-.972,18.438-5.074,24.663-17.7,45.677-34.625,64.214-7.41,8.115-15.832,15.336-23.673,23.081-3.47,3.428-6.64,7.148-9.946,10.735",
    transform: "translate(-210.21 -52.625)",
    fill: "#c4bfb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M1632.532,303.843c-3.176,1.763-6.718,3.095-9.468,5.357-17.237,14.184-34.664,28.177-51.324,43-21.959,19.531-43.237,39.8-64.9,59.652-2.861,2.622-6.262,4.674-9.413,6.991l-.4-.389c1.05-1.781,1.715-3.991,3.208-5.278,14.934-12.875,24.7-29.885,37.336-44.58,2.962-3.444,5.821-7.011,9.095-10.152a382.253,382.253,0,0,0,37.955-41.734c7.3-6.961,14.839-13.694,21.837-20.934q19.741-20.426,38.95-41.344c14.461-15.718,28.952-31.427,42.9-47.581,13.74-15.916,27.594-31.837,39.97-48.76a674.883,674.883,0,0,0,37.559-57.122c12.1-20.655,22.446-42.3,33.836-64.035a31.11,31.11,0,0,1,3.469,17.059c-1.858,22.013-9.063,42.6-19.015,62.171-9.769,19.21-19.846,38.337-31.089,56.735-7.248,11.862-16.5,22.616-25.472,33.377-10.532,12.638-21.321,25.12-32.744,36.98-11.862,12.315-24.737,23.685-36.936,35.7-8.438,8.309-19.622,13.939-25.349,24.9",
    transform: "translate(-193.759 -36.93)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M748.886,1113.031c-13.234-2.135-26.175-5.074-35.165-15.975-3.585-4.346-6.437-9.275-10.653-15.446-19.26-.622-35-8.745-39.389-30.931a22.491,22.491,0,0,0,1.863-3.945c2.46-9.613,4.65-19.294,7.227-28.876,8.763-32.579,17.875-65.08,20.971-98.81,6.2,4.308,12.483,8.495,18.528,13,1.569,1.167,2.373,3.319,3.529,5.019-.036,5.157.122,10.326-.149,15.471-.606,11.458-1.226,22.92-2.223,34.349-.811,9.292-2.218,18.532-3.291,27.8-1.176,10.166-2.388,20.33-3.369,30.515-.862,8.957-3.83,17.849-1.148,26.973a154.289,154.289,0,0,1,8.127-41.564c9.036-26.671,10.958-54.309,13.087-81.971l23.744,23.847c-4.709.938-3.151,4.413-2.927,7.214.385,4.767,1.488,9.53,1.382,14.274-.6,27.087,1.33,54.176-1.426,81.292-1.263,12.423.753,25.168,1.283,37.766",
    transform: "translate(-134.673 -115.136)",
    fill: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M1389.428,729.663c46.041.629,92.084,1.16,138.121,1.945,14.485.247,28.966,1.053,43.436,1.817q30.914,1.632,61.81,3.6,26.266,1.662,52.508,3.677c12.875.988,25.713,2.844,38.6,3.188a148.647,148.647,0,0,0,28.487-2.236c12.1-2.041,23.977-5.317,35.979-7.933a40.164,40.164,0,0,1,6.446-.377c-4.218,8.876-11.835,14.624-19.654,20.037-13.462,9.32-28.542,15.642-43.609,21.951-4.841.763-9.667,2.062-14.523,2.186-12.874.326-25.866,1.171-38.613-.1-15.838-1.577-31.48-5.053-47.2-7.738-16.62-2.838-33.249-5.637-49.85-8.585-21.781-3.869-43.478-8.352-65.8-7.724q-12.783-1.626-25.565-3.252c-10.676-1.362-21.454-2.21-32.006-4.209-16.276-3.085-33.039-3.877-48.727-9.931-3.917-1.512-8.346-1.748-12.539-2.571l-7.3-3.746",
    transform: "translate(-186.13 -98.346)",
    fill: "#9c9b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M1488.047,671.149c15.335-1.093,30.667-2.223,46.006-3.268,10.448-.712,20.924-1.08,31.351-2,17.753-1.574,35.486-3.374,53.208-5.249,17.113-1.81,34.3-3.243,51.275-5.906,24.581-3.856,49.072-8.352,73.473-13.2,14.462-2.871,28.7-6.862,42.995-10.506,4.471-1.139,8.839-2.7,13.2-4.22,5.521-1.929,10.84-5.107,16.5-5.831,16.492-2.107,24.96-14.152,34.512-25.061q4.47-5.1,8.965-10.184c0,10.176-7,17.229-12.168,24.875a238.858,238.858,0,0,1-19.354,24.315,84.1,84.1,0,0,1-14.918,13.455c-11.588,8-23.661,15.33-35.536,22.933-6.907,1.208-13.78,2.684-20.731,3.573a423.439,423.439,0,0,1-52.39,3.9c-16,.053-32,1.132-48,1.739s-32.035.718-47.993,1.88c-41.634,3.032-83.314,1.469-124.969,1.531-12.838.018-25.679-2.06-38.519-3.188-8.8-.774-17.605-1.564-26.425-3.211,7.088-4.616,15.136-1.718,22.624-3.073s15.334-.849,23.008-1.355c7.971-.526,15.925-1.287,23.887-1.946",
    transform: "translate(-188.193 -85.585)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M488.547,716.314c2.951.593,6.242.562,8.789,1.9,7,3.669,13.806,7.736,20.421,12.042,1.827,1.19,2.707,3.776,4.021,5.724-22.511.159-44.969,1.116-67.524-1.012-15.634-1.474-31.236-2.6-46.615-5.835-33.407-7.025-66.689-14.463-99.358-24.442-21.459-6.554-43.19-12.256-64.863-18.11-2.318-.626-5.064.275-7.611.468-10.6-6.251-20.985-12.764-29.73-20.729,1.707-4.695,4.462-4.909,7.256-4.243,14.409,3.428,29.059,3.679,43.741,3.211,2.856-.091,5.678-1.269,8.514-1.944q1.785.124,3.572.245l2.062,1.764c3.982.2,8.117-.2,11.922.71,14.617,3.506,29.126,7.454,43.684,11.2,40.693,10.469,81.363,21.026,122.11,31.284,7.984,2.01,16.278,2.838,24.43,4.211l7.472,1.732-.048-.025,7.754,1.85",
    transform: "translate(-102.229 -92.329)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M389.346,832.591c-6.23-2.6-12.535-5.03-18.672-7.822-9.615-4.376-15.509-12.731-21.756-20.557-2.832-3.547-2.586-7.946-1.068-12.178.819-2.281,1.586-4.58,2.343-6.882,1.233-3.746.17-6.341-3.661-8.047-5.612-2.5-11.079-5.308-16.609-7.986.433-4.061,3.611-3.566,6.271-3.387,8.242.553,16.494,1.1,24.7,2.032,13.657,1.552,27.237,3.9,40.927,4.994,15.581,1.243,31.246,1.474,46.874,2.144.318,2.38.3,4.867,1.027,7.122,1.337,4.146.036,6.486-4.253,7.211-2.457.414-4.964.616-5.144,4.976,2.932.189,5.845.6,8.746.527,22.181-.548,44.361-1.188,66.54-1.8q.911,0,1.823.017h1.779c-4.286,1.23-8.516,2.729-12.875,3.619-4.719.963-8.775,3.757-8.857,7.88-.164,8.264-2.564,16.542-.4,24.829-7.842,1.465-15.824,2.432-23.5,4.5-16.429,4.421-33.151,3.293-49.7,2.464-10.306-.515-20.489-3.717-30.674-5.948-2.465-.54-3.455.092-3.857,2.295",
    transform: "translate(-111.01 -101.533)",
    fill: "#979897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M1470.674,1161.826c-3.191-2.2-6.82-3.99-9.488-6.691a69.088,69.088,0,0,1-16.705-28.617c-7.514-24.2-14.533-48.578-22.953-72.476-3.874-10.995-10.22-21.23-16.2-31.38-1.77-3-6.123-4.543-9.293-6.753-.063-7.133,1.381-14.5-3.252-20.941-4.008-5.574-8.055-11.12-12.379-17.087,4.262-3.9,7-7.824,6.937-13.434-.02-1.9,3.146-3.831,4.855-5.753,7.412,11.388,14.89,22.741,22.221,34.185,11.936,18.629,23.316,37.622,35.817,55.876,8.541,12.468,18.243,24.227,28.09,35.758,6.318,7.4,13.952,13.7,20.775,20.707,2.944,3.022,5.106,6.776,8.037,9.813,2.439,2.528,5.483,4.494,8.259,6.71,1.188,9.954-2.519,17.559-11.074,23.112a37.372,37.372,0,0,0-7.515,6.625c-6.954,7.875-15.5,11.566-26.131,10.347",
    transform: "translate(-185.49 -118.651)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M1525.185,755.672c22.325-.628,44.022,3.856,65.8,7.724,16.6,2.948,33.229,5.747,49.851,8.585,15.722,2.685,31.365,6.162,47.2,7.738,12.748,1.269,25.741.424,38.614.1,4.856-.123,9.682-1.423,14.524-2.185,1.178,1.258,2.158,2.814,3.575,3.7a69.665,69.665,0,0,0,6.65,3.1c14.189,6.892,16.389,13.053,9.9,27.617-9.066,2.647-18.1,5.425-27.22,7.868a41.078,41.078,0,0,1-9.984,1.249c-11.415.147-22.873.634-34.241-.095-14.041-.9-28.218-1.883-41.967-4.62-26.727-5.322-53.2-11.874-79.769-17.969-3.2-.735-6.321-1.8-9.479-2.711a42.737,42.737,0,0,1,5.2-1.768c9.8-2.031,19.626-3.959,31.176-6.268-2.987-4.855-4.848-8.518-7.3-11.745-5.612-7.376-14.435-9.186-22.738-11-11.642-2.537-23.572-3.786-35.324-5.88-1.648-.294-2.987-2.256-4.47-3.446",
    transform: "translate(-195.756 -100.647)",
    fill: "#a6a6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M446.442,771.513c-15.629-.672-31.293-.9-46.875-2.146-13.688-1.092-27.27-3.442-40.927-4.994-8.2-.932-16.455-1.478-24.7-2.031-2.661-.179-5.838-.674-6.272,3.387a71.136,71.136,0,0,1-23.952-14.736c-5.58-5.1-7.013-10.306-4.01-16.953,1-2.206,1.962-4.427,2.935-6.64,12.349.081,24.726-.277,37.051.353,15.006.767,29.933,2.524,44.479,6.586,11.236,3.138,22.354,7.07,33.814,8.96,20.238,3.336,40.641,5.97,61.078,7.792,16.835,1.5,33.823,1.3,50.734,2.06,5.8.26,11.574,1.145,17.36,1.746,11.243,7.519,22.894,14.56,31.166,25.564-4.8.85-9.671,1.434-14.388,2.606-10.092,2.509-20.011,5.773-30.192,7.812-4.829.967-10.367,2.283-15.047-1.407,2.018-7.542,9.142-7.322,14.742-8.8,7.087-1.874,14.476-2.623,21.692-4.065,2.877-.575,6.128-1.195,6.2-6.377a64.034,64.034,0,0,0-8.029-.49c-16.545,1.057-33.07,2.974-49.623,3.213-19.069.274-38.158-.894-57.238-1.436",
    transform: "translate(-108.758 -98.143)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M1579.958,314.549c-4.589,4.848-9.008,9.866-13.81,14.5-5.47,5.279-11.28,10.221-16.948,15.3q-17.007,15.242-34.02,30.477c1.421-3.241,2.309-6.854,4.347-9.664,13.412-18.478,27.284-36.637,40.587-55.189,12.42-17.322,24.089-35.162,36.512-52.483,15.848-22.1,28.14-46.219,42.117-69.38,8.261-13.69,13.633-28.474,19.375-43.138,7.18-18.333,13.7-36.913,20.725-55.308,1.55-4.06,4-7.791,6.488-12.542,6.909,7.462,9.073,15.159,9.99,23.314a71.153,71.153,0,0,1-4.6,33.033c-6.928,18.433-13.891,37.045-23.158,54.39-11,20.591-24.072,40.161-36.963,59.718-9.363,14.2-19.715,27.792-29.961,41.412-6.58,8.747-13.767,17.053-20.681,25.557",
    transform: "translate(-195.046 -40.494)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M1646.176,967.7c-17.148-7.758-31.979-19.094-46.661-30.371-19.754-15.172-38.477-31.632-57.9-47.234-7.388-5.937-13.8-12.486-18.441-20.667,3.352.088,6.775-.223,10.041.341,13.2,2.281,26.031,2.233,38.06-4.575,1.558,2.062,2.713,4.679,4.74,6.094,14.474,10.109,28.728,20.6,43.819,29.753,18.563,11.259,38.157,20.748,59.108,27.168,3.581,1.1,7.921,3.552,9.615-2.614,3.573,3.351,1.972,7.271.761,10.785a25.905,25.905,0,0,1-4.847,8.6c-10.241,11.58-22,20.885-38.3,22.719",
    transform: "translate(-195.614 -110.362)",
    fill: "#979897"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M1218.156,1069.475c8.187,13.062,16.331,26.15,24.568,39.182,13.878,21.958,28.051,43.653,39.061,67.322,9.153,19.676,20.777,38.244,31.247,57.333,1.818,3.315,6.353,5.27,5.28,10.044a1.134,1.134,0,0,1-.923.449q-.427.835-.857,1.67a8.734,8.734,0,0,1,.008,2.71c-1.066,3.3-1.339,8.035-3.677,9.475-4.051,2.495-8.541-.541-11.411-3.678-7-7.649-13.769-15.532-20.142-23.688-7.692-9.843-14.877-20.067-22.286-30.122q-6.125-8.311-12.267-16.61c-1.249-3.035-2.313-6.159-3.783-9.087-5.725-11.4-11.579-22.742-17.385-34.1,2.743-7.429,2.5-7.853-5.328-9.347l-1.894-3.633c2.439-4.634,2.067-5.376-3.663-7.3l-3.817-7.34,4.2-16.922c-7.371-1.1-12.135-4.388-11.509-11.257.709-7.771,2.371-15.489,10.99-19.1l3.593,4",
    transform: "translate(-172.949 -128.118)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M811.573,1150.334c-3.985-.191-8.013-.843-11.947-.492-15.605,1.392-30.617-11.521-33.7-23.312a53.635,53.635,0,0,0-2.286-5.9c.6-2.951,1.629-5.889,1.731-8.858.763-22.076,1.508-44.156,1.926-66.239.355-18.806.267-37.621.372-56.429,1.086.488,2.428.723,3.224,1.5,6.371,6.2,12.638,12.5,18.937,18.765-.591,1.867-1.99,3.888-1.652,5.575,5.6,27.93,11.493,55.8,17.145,83.72,3.452,17.053,6.75,34.147,6.254,51.671",
    transform: "translate(-141.761 -121.347)",
    fill: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M431.785,669.558c2.557,1.463,5.143,2.879,7.666,4.4,9.038,5.443,18.2,10.781,21.6,21.71l8.116,2.9q-3.846,1.988-7.691,3.971c-7.235-1.369-14.6-2.264-21.685-4.182-28.5-7.719-56.882-15.882-85.376-23.638-26.508-7.214-51.76-17.545-76.609-28.942,6.8-5.71,12.747-12.1,16.778-20.044,9.1,2.659,18.263,5.118,27.281,8.018,19.268,6.193,38.443,12.659,57.7,18.9,3.167,1.027,6.534,1.461,9.809,2.169l-.082-.043c1.629,2.158,3.362,2.58,5.256.3,10.27,4.58,20.5,9.249,30.847,13.661,1.893.807,4.25.571,6.393.818",
    transform: "translate(-107.314 -89.132)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M827.4,1033.159c.6,9.624.994,19.266,1.837,28.869,1.815,20.7,8.822,40.066,16.906,59.019,5.936,13.917,12.333,27.691,19.42,41.072,4.081,7.706,10.262,14.315,14.872,21.789,2.267,3.675,3.111,8.192,4.6,12.326-8.2.906-14.271-2.451-18.861-8.935-2.612-3.691-5.925-5.81-10.9-5.148-13.576,1.807-23.058-3.944-29.5-15.525-1.986-3.571-4.891-6.649-7.375-9.954,4.062-4.492,2.118-9.912,1.832-14.787-.705-12.015-2.943-23.967-3.243-35.976-.409-16.424-4.652-32.2-6.893-48.3-1.578-11.333-3.026-22.685-4.533-34.028,3.284,1.3,6.614,2.5,9.841,3.926,4.042,1.787,8,3.759,11.994,5.651",
    transform: "translate(-144.734 -124.404)",
    fill: "#888a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M542.9,751.47c-5.786-.6-11.559-1.484-17.361-1.745-16.911-.76-33.9-.56-50.732-2.06-20.437-1.821-40.841-4.455-61.079-7.792-11.46-1.889-22.578-5.821-33.814-8.958-14.545-4.064-29.474-5.82-44.479-6.586-12.324-.63-24.7-.273-37.052-.354-10.091-5.667-20.229-11.266-30.276-17.018s-20.027-11.673-30.033-17.519c2.548-.193,5.295-1.095,7.612-.469,21.673,5.855,43.406,11.556,64.863,18.111,32.67,9.979,65.952,17.417,99.359,24.442,15.378,3.234,30.982,4.362,46.614,5.835,22.555,2.127,45.014,1.171,67.525,1.012,8.19,1.73,13.724,7.135,18.853,13.1",
    transform: "translate(-104.497 -94.719)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M269.017,643.474c24.849,11.4,50.1,21.727,76.609,28.942C374.12,680.171,402.5,688.334,431,696.054c7.081,1.917,14.45,2.812,21.684,4.181q8.462,2.62,16.93,5.233.039.891.05,1.785c-8.152-1.372-16.447-2.2-24.432-4.21-40.747-10.259-81.417-20.816-122.109-31.285-14.56-3.745-29.068-7.694-43.686-11.2-3.806-.912-7.938-.51-11.923-.711l-2.059-1.764-3.573-.245c-15.9-7.273-31.565-15.076-47.745-21.68-19.557-7.983-37.422-18.625-54.528-30.657-2.2-1.549-3.863-3.836-5.775-5.781,3.525.8,7.163,1.291,10.555,2.466,9.522,3.3,18.942,6.889,28.4,10.362,10.727,4.3,21.472,8.552,32.178,12.9q22.046,8.955,44.046,18.022",
    transform: "translate(-98.525 -86.826)",
    fill: "#b1ada7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M1766.784,555.537c9.027-2.88,17.958-6.1,27.1-8.575,28.019-7.579,55.5-16.545,81.8-28.815,2.444-1.14,5.113-4.267,8.176-.766a16.137,16.137,0,0,0-2.17,1.657c-15.66,16.695-33.874,30.37-52.853,43.154a13.032,13.032,0,0,0-2.312,2.748q-15.893,3.241-31.79,6.469c-1.761.355-3.559.541-5.34.8-.413-3.824-3.351-3.91-6.087-3.573-8.21,1.012-12.464-2.99-14.483-10.294-.289-1.041-1.342-1.877-2.041-2.809",
    transform: "translate(-212.886 -79.383)",
    fill: "#b6b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M992.687,1358.456c7.328.809,11.106,5.6,13.7,11.732a99.889,99.889,0,0,0,4.726,9.315c2.4,3.766,5.4,7.215,3.533,12.122-6.737.831-12.6-.693-17.67-5.447-2.38-2.231-5.53-3.673-8.714-5.719-6.158,3.15-11.315,6.952-13.142,14.482,6.763,1.393,13.447,1,16.421,7.7-.21,2.6.276,5.654-3.862,5.69l-14.422-11.121c-.75,1.151-1.558,2.392-2.367,3.638-2.965,1.72-6.028,3.293-8.856,5.2a46.925,46.925,0,0,0-5.037,4.514c-3.631-6.068-4.126,1.173-6.27,1.423-5.553-2.39-7.137,4.237-12.848,5.789a90.96,90.96,0,0,1,.745-9.269c.837-4.433,2.184-8.811-1-12.911,15.367-16.642,35.887-25.933,55.063-37.143",
    transform: "translate(-154.097 -154.093)",
    fill: "#bd1214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M271.99,643.979q-22.021-9.015-44.046-18.022c-10.706-4.349-21.451-8.6-32.177-12.9,3.291-1.274,6.538-2.669,9.881-3.789,4.177-1.4,8.433-2.571,12.655-3.841,9.21,1.9,18.545,3.362,27.6,5.809,14.385,3.886,28.585,8.433,42.862,12.7-4.03,7.94-9.979,14.334-16.778,20.044",
    transform: "translate(-101.498 -87.331)",
    fill: "#e1ddd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M766.953,988.091c-.108,18.811-.02,37.625-.375,56.431-.417,22.084-1.163,44.164-1.925,66.24-.1,2.968-1.132,5.905-1.732,8.857l-7.661-1.389c-.53-12.6-2.547-25.343-1.284-37.766,2.756-27.116.822-54.2,1.426-81.291.106-4.746-1-9.507-1.381-14.274-.226-2.8-1.782-6.276,2.928-7.215,1.933,1.759,3.954,3.435,5.768,5.305,1.537,1.585,2.834,3.393,4.237,5.1",
    transform: "translate(-141.046 -120.335)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M692.968,918.382c-3.1,33.733-12.21,66.234-20.973,98.813-2.577,9.581-4.767,19.262-7.228,28.876a22.47,22.47,0,0,1-1.863,3.945q-5.07-3.515-10.143-7.027c4.944-4.139,4.5-10.373,5.612-15.679,6.13-29.142,14.348-57.752,22.133-86.473,2.655-9.793,5.579-19.516,8.379-29.271l4.081,6.817",
    transform: "translate(-133.899 -114.473)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M212.953,602.156c-4.222,1.269-8.478,2.441-12.655,3.84-3.343,1.12-6.589,2.515-9.88,3.789-9.462-3.473-18.882-7.058-28.4-10.361-3.39-1.176-7.029-1.664-10.555-2.466l.1.067-5.642-3.735c-10.007-5.4-18.305-12.75-25.589-20.968.941-4.329,3.236-4.218,6.319-3.179,8.136,2.744,16.455,5,24.5,7.963,19.254,7.1,38.407,14.466,57.553,21.841,1.6.616,2.845,2.117,4.254,3.207",
    transform: "translate(-96.149 -84.062)",
    fill: "#e8e1d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M1381.723,1887.921c-7.762-3.069-8.7-10.707-10.684-16.95-12.284-38.66-23.936-77.512-35.985-116.244-8.174-26.28-16.672-52.464-24.949-78.714a6.873,6.873,0,0,1,.705-5.381c.9,2.149,1.942,4.25,2.665,6.452q13.6,41.389,27.1,82.807c.559,1.708.46,4.224,1.628,5.04,6.518,4.555,7.308,11.887,9.216,18.372,4.966,16.874,10.633,33.407,18.536,49.223,2.4,4.809,3.115,10.413,4.791,15.594,2.12,6.557,5.046,12.927,6.472,19.615,1.183,5.557.7,11.455.95,17.2q-.224,1.491-.449,2.983",
    transform: "translate(-180.487 -181.77)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M823.272,716.9c-5.967,4.553-7.332,10.99-7.606,17.874-9.961.845-19.086,4.406-28.176,8.174-9.292,3.853-13.883,11.462-16.947,20.68-4.264-3.069-4.159-7.18-3.994-10.919.6-13.657,8.481-23.639,18.015-32.593,1.195-1.122,3.394-1.155,5.034-1.894,3.589-1.618,7.153-3.3,10.661-5.078,3.963-2.009,7.854-4.153,11.874-6.291,1.953,3.57,3.447,6.168,4.811,8.829,1.61,3.143,4,1.911,6.327,1.218",
    transform: "translate(-141.963 -96.324)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M804.462,1022.5c1.506,11.344,2.956,22.694,4.533,34.029,2.241,16.1,6.484,31.875,6.893,48.3.3,12.009,2.537,23.961,3.243,35.977.286,4.875,2.23,10.3-1.833,14.788l-3.856-3.284c.5-17.522-2.8-34.616-6.254-51.669-5.652-27.92-11.549-55.791-17.144-83.721-.338-1.687,1.061-3.708,1.65-5.574l12.769,11.156",
    transform: "translate(-143.629 -123.319)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M579.7,992.314c.785-1.17,1.316-2.68,2.4-3.454,6.415-4.585,12.991-8.952,19.434-13.5,1.993-1.406,3.511-3.574,5.636-4.664,9.984-5.126,15.787-14.1,22.272-22.514,11.461-14.87,18.857-31.85,26.617-48.655.465-1,1.288-1.849,3.319-2.265a69.812,69.812,0,0,1-1.837,7.215c-4.266,11.639-7.586,23.767-13.257,34.719-7.789,15.037-17.389,29.172-26.222,43.69-.155.254-.474.416-.616.674-3.7,6.749-9.039,11.177-17.145,11.717q-4.777-.007-9.555-.008-2.777-.55-5.555-1.1l-5.488-1.855",
    transform: "translate(-128.719 -113.205)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M99.848,481.77A60.4,60.4,0,0,1,106.7,485.9c12.888,10.234,25.618,20.658,38.519,30.874a418.493,418.493,0,0,0,64.267,42.408c21.676,11.44,44.2,21.329,66.279,32.045,6.562,3.184,12.879,6.855,19.307,10.308q-.042,1.081-.083,2.154c-13-5.465-25.975-11.012-39.021-16.381-34.256-14.1-66.019-32.64-96.584-53.1-16.49-11.038-32.245-23.195-47.744-35.556-5.3-4.224-10.263-9.652-11.794-16.883",
    transform: "translate(-94.697 -76.368)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M171.424,405.744c1.258,2.324,3.154,4.52,3.667,6.993,2.58,12.445,9.192,22.993,15.568,33.736,17.03,28.7,41.358,51.179,65.663,73.521,11.862,10.9,25.589,19.837,38.265,29.914,4.013,3.19,7.354,7.192,11,10.821q.042.6.054,1.206A560.87,560.87,0,0,1,248.022,519.8a306.156,306.156,0,0,1-62.548-70.948c-5.15-8.077-8.935-17.159-12.154-26.189-1.861-5.218-1.343-11.252-1.9-16.919",
    transform: "translate(-99.772 -69.628)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M937.2,1399.213c3.182,4.1,1.836,8.478,1,12.911a90.919,90.919,0,0,0-.745,9.268c5.71-1.551,7.294-8.178,12.848-5.789-2.454,10.282-5.181,20.511-7.258,30.867-1.213,6.044-.114,11.812,4.75,16.545,2.431,2.365,4.161,5.422,6.51,8.568-7.614,1.8-10.528-3.722-12.913-7.506-6.192-9.827-11.069-20.343-8.579-32.613a16.116,16.116,0,0,0-.239-8.1c-1.835-5.33-.638-10.124,1.342-14.977,3.972-1.971,2.5-4.57.859-7.189l2.426-1.988",
    transform: "translate(-153.674 -157.707)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M393.881,838.632c.4-2.2,1.392-2.835,3.857-2.295,10.185,2.231,20.369,5.433,30.674,5.948,16.55.828,33.272,1.957,49.7-2.464,7.675-2.066,15.657-3.033,23.5-4.5q7.443-.786,14.886-1.575l4.74,3.293c-33.072,4.829-64.731,12.557-97.571,11.172-4.534-1.357-9.093-2.638-13.595-4.093-5.423-1.752-10.8-3.653-16.191-5.49",
    transform: "translate(-115.544 -107.574)",
    fill: "#888a8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M958.472,1414.691a46.83,46.83,0,0,1,5.038-4.514c2.827-1.909,5.891-3.483,8.855-5.2-.835,5.318-2.244,10.625-2.384,15.964-.288,10.955,2.929,20.848,11.675,28.523-6.512,2.336-11.116,1.133-14.452-4.749a69.655,69.655,0,0,1-6.024-15.039c-1.4-4.856-1.844-9.978-2.708-14.982",
    transform: "translate(-155.575 -158.217)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M425.927,847.985c32.841,1.384,64.5-6.343,97.571-11.173l-4.74-3.293q7.367-.928,14.737-1.854c2.107,2.21,4.008,2.206,5.656-.507l7.2.279c-2.319,1.321-4.486,3.121-6.982,3.885-19.346,5.92-38.872,10.641-59.149,13.034-18.218,2.151-36.319.6-54.448,1.409q.077-.89.152-1.78",
    transform: "translate(-117.806 -107.344)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M309.884,615.343q.04-1.075.083-2.154c12.266,4.741,24.8,8.911,36.742,14.346,29.266,13.326,58.255,27.235,87.354,40.909-2.146-.244-4.5-.008-6.4-.817-10.345-4.412-20.577-9.081-30.846-13.662l-5.257-.3.082.042c-5.035-6.169-12.707-7.953-19.523-11.016-20.667-9.286-41.481-18.255-62.238-27.349",
    transform: "translate(-109.589 -88.02)",
    fill: "#b6b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M835.7,1689.215c2.4,1.292,4.864,2.488,7.181,3.912,1.236.76,2.922,1.75,3.2,2.915,1.677,6.956,3,13.994,4.449,21-10.614-6.37-16.831-15-14.832-27.832",
    transform: "translate(-146.844 -183.417)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M991.5,1412.631c4.137-.033,3.652-3.088,3.862-5.688,8.718,4.538,9.755,13.778,14.146,21.52-4.3,2.289-6.534-.1-8.5-2.7-3.257-4.312-6.349-8.744-9.509-13.127",
    transform: "translate(-157.916 -158.392)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M1019.891,1391.731c1.87-4.907-1.132-8.354-3.533-12.122a99.838,99.838,0,0,1-4.726-9.315c.938-3.3,1.876-6.6,3.024-10.645,4.775,5.187,1.1,11.23,3.078,15.694l12.136,2.581c-.963,6.243-8.855,6.718-7.709,12.727-.758.353-1.514.716-2.269,1.079",
    transform: "translate(-159.344 -154.199)",
    fill: "#9c9b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M1325.26,1429.222c-5.561-.248-9.989-5.55-16.082-3.463q-1.806-6.519-3.6-13.035l3.054-5.263,16.623,21.761",
    transform: "translate(-180.186 -158.438)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M1449.962,477.7c-11.237,12.9-23.137,25.106-37.738,34.443a27.777,27.777,0,0,1-5,1.986c.461-1.058.63-2.441,1.424-3.125q18.175-15.659,36.537-31.109c1.287-1.081,3.172-1.48,4.779-2.2",
    transform: "translate(-187.392 -76.007)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M1921.142,485.7c2.2-5.48,4.38-10.972,6.626-16.435.778-1.892,1.728-3.716,2.6-5.572.907,1.174,2.806,2.616,2.563,3.481-2.037,7.274-4.839,14.211-11.789,18.526",
    transform: "translate(-223.83 -74.766)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M1428.389,1538.157c-9.246-1.674-9.879-2.339-10.869-11.407l10.869,11.407",
    transform: "translate(-188.122 -169.014)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M934.458,1401.394c1.644,2.619,3.112,5.217-.859,7.188l-6.415.751,7.274-7.939",
    transform: "translate(-153.356 -157.9)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M931.043,1574.157q-.155,7.237-7.459,8.268l7.459-8.268",
    transform: "translate(-153.101 -173.217)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M1413.292,1522.195c-5.632-.075-7.84-3.356-8.162-8.4l8.162,8.4",
    transform: "translate(-187.244 -167.865)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M328.948,585.048q-3.569-.948-7.136-1.9-2.032-2.718-4.067-5.434c4.527,1.263,9.493,1.869,11.29,7.234l-.087.1",
    transform: "translate(-110.146 -84.875)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M1308.495,1407.09q-1.525,2.631-3.053,5.262l-1.856-9.077a15.574,15.574,0,0,1,1.588.077l3.321,3.737",
    transform: "translate(-180.044 -158.067)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M1334.783,1440.51c-4.637-.657-7.25-3.082-7.151-7.877l7.151,7.877",
    transform: "translate(-181.749 -160.67)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M875.561,1728.989l15.348.141c-.053.413-.126.826-.212,1.235l-15.136-1.376",
    transform: "translate(-149.696 -186.944)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M1514.636,403.72c-.6,4.63-3.89,7.115-7.663,9.211,1.462-3.943,2.189-8.477,7.663-9.211",
    transform: "translate(-194.464 -69.449)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M1020.77,1474.615c.41,4.261-1.881,6.027-5.926,6.171q2.964-3.085,5.926-6.171",
    transform: "translate(-159.572 -164.392)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M847.319,1667.877c-.163,3.784-1.318,6.687-5.977,6.484l5.977-6.484",
    transform: "translate(-147.27 -181.525)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M858.956,1654.719q.3,5.636-5.453,5.834l5.453-5.834",
    transform: "translate(-148.132 -180.359)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M1478.838,449.661l-5.641,7.35,5.641-7.35",
    transform: "translate(-192.07 -73.522)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M941.115,1563.212c.45,3.825-1.157,5.811-5.211,5.61l5.211-5.61",
    transform: "translate(-153.975 -172.246)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M875.338,1636.024c.045,2.636-.532,4.767-3.909,4.619q1.954-2.31,3.909-4.619",
    transform: "translate(-149.403 -178.702)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M1003.453,1494.074c-.153,2.476-.586,4.733-3.876,4.742q1.939-2.371,3.876-4.742",
    transform: "translate(-158.489 -166.117)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M1305.025,1402.868q-.791-.079-1.588-.078-.973-2.49-1.944-4.979,1.766,2.531,3.531,5.058",
    transform: "translate(-179.896 -157.582)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M147.868,595.7l5.642,3.734-5.642-3.734",
    transform: "translate(-98.101 -86.469)",
    fill: "#b1ada7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M963.056,1538.8c.206,2.555-.911,3.958-3.608,3.986l3.608-3.986",
    transform: "translate(-155.644 -170.082)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M892.38,1730.815c2.3.75,3.446,1.837,1.2,3.923q-.6-1.962-1.2-3.923",
    transform: "translate(-150.889 -187.106)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M1917.153,491.5l3.725-3.659-3.725,3.659",
    transform: "translate(-223.547 -76.907)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M585.6,1003.6l5.556,1.1-5.556-1.1",
    transform: "translate(-129.137 -122.632)",
    fill: "#8f9193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M1460.93,469.7l-3.713,3.642,3.713-3.642",
    transform: "translate(-190.937 -75.299)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M865.719,1727.069l5.475,1.432-5.475-1.432",
    transform: "translate(-148.998 -186.774)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M1915.1,495.477l1.914-3.666-1.914,3.666",
    transform: "translate(-223.401 -77.259)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M1337.162,1443.1l-1.79-1.785,1.79,1.785",
    transform: "translate(-182.298 -161.439)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M1338.989,1445.143q-.812-.9-1.624-1.8l1.624,1.8",
    transform: "translate(-182.439 -161.619)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M1342.707,1449.244q-.715-.761-1.429-1.522l1.429,1.522",
    transform: "translate(-182.717 -162.007)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M1344.488,1451.26a3.285,3.285,0,0,1-1.25-1.306q.624.654,1.25,1.306",
    transform: "translate(-182.856 -162.205)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M1346.387,1453.248a3.313,3.313,0,0,1-1.14-1.188l1.14,1.188",
    transform: "translate(-182.998 -162.392)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M1347.939,1454.982a2.609,2.609,0,0,1-.662-.7l.638.1Z",
    transform: "translate(-183.142 -162.589)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M1359.23,1467.057l-1.849-1.833,1.849,1.833",
    transform: "translate(-183.858 -163.559)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M1027.331,1467.232l-1.754,1.877,1.754-1.877",
    transform: "translate(-160.333 -163.737)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M1361.221,1469.07l-1.838-1.823,1.838,1.823",
    transform: "translate(-184 -163.738)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M1025.388,1469.367l-1.637,1.782,1.637-1.782",
    transform: "translate(-160.203 -163.926)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M1365.16,1473.093l-1.81-1.785,1.81,1.785",
    transform: "translate(-184.281 -164.098)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M1367.1,1475.114l-1.749-1.8,1.749,1.8",
    transform: "translate(-184.423 -164.276)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M1369.14,1477.1l-1.818-1.709,1.818,1.709",
    transform: "translate(-184.563 -164.46)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M1371.276,1479.052l-1.927-1.73,1.927,1.73",
    transform: "translate(-184.707 -164.632)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M1377.034,1485.047q-.786-1.043-1.57-2.088.785,1.044,1.57,2.088",
    transform: "translate(-185.14 -165.131)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M1011.407,1485.433q-.8.86-1.594,1.72l1.594-1.72",
    transform: "translate(-159.215 -165.35)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M1912.954,497.662l2.031-1.895-2.031,1.895",
    transform: "translate(-223.249 -77.609)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M1007.493,1490.079a3.226,3.226,0,0,1-1.153,1.163l1.153-1.163",
    transform: "translate(-158.969 -165.762)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M1005.515,1492.094a3.311,3.311,0,0,1-1.142,1.144l1.142-1.144",
    transform: "translate(-158.829 -165.941)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M1391.08,1499.147l-1.708-1.492,1.708,1.492",
    transform: "translate(-186.127 -166.434)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M999.388,1499.346l-1.679,1.782,1.679-1.782",
    transform: "translate(-158.357 -166.584)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M1392.956,1501.153l-1.659-1.768,1.659,1.768",
    transform: "translate(-186.263 -166.587)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M997.427,1501.461l-1.624,1.7,1.624-1.7",
    transform: "translate(-158.222 -166.772)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M1394.851,1503.187l-1.594-1.66,1.594,1.66",
    transform: "translate(-186.402 -166.778)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M995.466,1503.566l-1.537,1.6,1.537-1.6",
    transform: "translate(-158.089 -166.958)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M1396.8,1505.2l-1.566-1.57,1.566,1.57",
    transform: "translate(-186.542 -166.964)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M1398.764,1507.208l-1.536-1.542,1.536,1.542",
    transform: "translate(-186.683 -167.145)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M991.5,1507.909q-.644.662-1.289,1.322l1.289-1.322",
    transform: "translate(-157.825 -167.343)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M1400.725,1509.215l-1.5-1.477,1.5,1.477",
    transform: "translate(-186.825 -167.328)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M989.57,1510.058a2.488,2.488,0,0,1-.76.9l.073-.685Z",
    transform: "translate(-157.726 -167.534)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M1402.729,1511.208l-1.5-1.5,1.5,1.5",
    transform: "translate(-186.967 -167.502)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M1404.6,1513.225q-.691-.7-1.381-1.411l1.381,1.411",
    transform: "translate(-187.108 -167.689)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M983.344,1517.177l-1.7,1.906,1.7-1.906",
    transform: "translate(-157.218 -168.165)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M975.468,1525.537l-1.554,1.636,1.554-1.636",
    transform: "translate(-156.67 -168.906)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M973.509,1527.693l-1.448,1.485,1.448-1.485",
    transform: "translate(-156.538 -169.097)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M1473.087,457.708l-1.865,1.831,1.865-1.831",
    transform: "translate(-191.93 -74.235)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M969.507,1531.941a3.048,3.048,0,0,1-1.256,1.278l1.256-1.278",
    transform: "translate(-156.268 -169.474)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M967.553,1533.967a2.212,2.212,0,0,1-1,1.037q-.085-1.048,1-1.037",
    transform: "translate(-156.147 -169.654)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M1431.07,1541.084l-1.774-1.743,1.774,1.743",
    transform: "translate(-188.957 -170.13)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M1433.045,1543.094l-1.75-1.75,1.75,1.75",
    transform: "translate(-189.099 -170.308)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M959.332,1543.159l-1.78,1.887,1.78-1.887",
    transform: "translate(-155.51 -170.469)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M1471.081,459.715l-1.854,1.821,1.854-1.821",
    transform: "translate(-191.788 -74.413)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M1435,1545.107l-1.715-1.739,1.715,1.739",
    transform: "translate(-189.24 -170.487)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M957.391,1545.268l-1.679,1.833,1.679-1.833",
    transform: "translate(-155.379 -170.656)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M1436.986,1547.115l-1.721-1.683,1.721,1.683",
    transform: "translate(-189.38 -170.67)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M955.467,1547.44,954,1549.024l1.463-1.584",
    transform: "translate(-155.258 -170.848)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M1439.031,1549.106l-1.761-1.694,1.761,1.694",
    transform: "translate(-189.522 -170.846)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M1441.032,1551.091l-1.761-1.715,1.761,1.715",
    transform: "translate(-189.665 -171.02)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M951.294,1552.551s-.44.433-.436.432-.049-.478-.049-.478Z",
    transform: "translate(-155.031 -171.297)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M1445.119,1555.053q-.912-.862-1.823-1.724.911.864,1.823,1.724",
    transform: "translate(-189.95 -171.37)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M947.22,1556.728l-.452.455-.02-.5Z",
    transform: "translate(-154.744 -171.667)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M1447.2,1557.028l-1.887-1.748,1.887,1.748",
    transform: "translate(-190.093 -171.543)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M945.47,1558.584s-.205.2-.2.194-.218-.25-.218-.25Z",
    transform: "translate(-154.623 -171.831)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M1469.078,461.718l-1.844,1.811,1.844-1.811",
    transform: "translate(-191.647 -74.591)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M1467.074,463.724l-1.842,1.807,1.842-1.807",
    transform: "translate(-191.505 -74.768)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M1465.077,465.719l-1.843,1.809,1.843-1.809",
    transform: "translate(-191.363 -74.945)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M935.548,1569.69,934.294,1571l1.254-1.314",
    transform: "translate(-153.861 -172.821)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1463.076,467.72l-1.839,1.806,1.839-1.806",
    transform: "translate(-191.222 -75.123)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1457.081,473.717l-1.843,1.809,1.843-1.809",
    transform: "translate(-190.796 -75.654)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1893.086,585.621l1.883-1.91-1.883,1.91",
    transform: "translate(-221.841 -85.406)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1455.082,475.715l-1.844,1.81q.922-.9,1.844-1.81",
    transform: "translate(-190.655 -75.832)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M98.183,479.825l1.664,1.853-1.664-1.853",
    transform: "translate(-94.579 -76.196)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M923.42,1583.271l-1.686,1.819,1.686-1.819",
    transform: "translate(-152.97 -174.024)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M315.881,577.013q-.011-.6-.054-1.207.948.917,1.9,1.832l-1.842-.625",
    transform: "translate(-110.01 -84.705)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M921.471,1585.408l-1.628,1.716,1.628-1.716",
    transform: "translate(-152.836 -174.214)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M919.522,1587.565l-1.485,1.595,1.485-1.595",
    transform: "translate(-152.708 -174.405)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M917.541,1589.7l-1.461,1.453q.73-.728,1.461-1.453",
    transform: "translate(-152.569 -174.595)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M977.438,1523.521l-1.642,1.629,1.642-1.629",
    transform: "translate(-156.803 -168.728)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M911.579,1596.118a2.321,2.321,0,0,1-.832.842l.13-.683Z",
    transform: "translate(-152.191 -175.164)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M1325.156,1262.824q.429-.835.857-1.67-.431.835-.857,1.67",
    transform: "translate(-181.573 -145.467)",
    fill: "#838789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M903.449,1605.334l-1.61,1.755,1.61-1.755",
    transform: "translate(-151.559 -175.981)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M899.517,1609.591l-1.482,1.566,1.482-1.566",
    transform: "translate(-151.29 -176.358)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M897.586,1611.772l-1.224,1.393,1.224-1.393",
    transform: "translate(-151.171 -176.552)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M895.586,1614.066a3.813,3.813,0,0,1-1.006,1.094.928.928,0,0,1,1.006-1.094",
    transform: "translate(-151.045 -176.755)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M893.566,1616.379s-.442.469-.438.468-.092-.461-.092-.461Z",
    transform: "translate(-150.935 -176.96)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M889.341,1621.01l-1.86,1.963,1.86-1.963",
    transform: "translate(-150.541 -177.37)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M885.432,1625.26l-1.742,1.784,1.742-1.784",
    transform: "translate(-150.273 -177.747)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M879.525,1631.552q-.685.719-1.368,1.437l1.368-1.437",
    transform: "translate(-149.88 -178.305)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M871.346,1641.044l-1.774,1.937,1.774-1.937",
    transform: "translate(-149.272 -179.147)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M869.416,1643.2l-1.713,1.837,1.713-1.837",
    transform: "translate(-149.139 -179.338)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M867.469,1645.329l-1.7,1.738,1.7-1.738",
    transform: "translate(-149.002 -179.527)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M865.5,1647.388l-1.611,1.691,1.611-1.691",
    transform: "translate(-148.869 -179.709)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M861.61,1652a2.343,2.343,0,0,1-.768.9l.087-.682Z",
    transform: "translate(-148.653 -180.118)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M853.393,1661.1l-1.686,1.918,1.686-1.918",
    transform: "translate(-148.005 -180.925)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M851.492,1663.325l-1.589,1.744,1.589-1.744",
    transform: "translate(-147.877 -181.122)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M841.3,1674.925q-.953.976-1.9,1.953.952-.978,1.9-1.953",
    transform: "translate(-147.132 -182.15)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M839.343,1676.987l-1.541,2.041,1.541-2.041",
    transform: "translate(-147.019 -182.333)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M837.62,1679.465a2.344,2.344,0,0,1-.78,1.351q.391-.675.78-1.351",
    transform: "translate(-146.951 -182.553)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M896.722,1753.133q.33,1.007.66,2.015-.33-1.007-.66-2.015",
    transform: "translate(-151.197 -189.084)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M898.893,1759.142q.359.812.718,1.625-.36-.812-.718-1.625",
    transform: "translate(-151.351 -189.617)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M1560.734,1781.345q1.121.585,2.244,1.172-1.122-.584-2.244-1.172",
    transform: "translate(-198.276 -191.585)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M913.541,1594.077a3.435,3.435,0,0,1-1.082,1.113.994.994,0,0,1,1.082-1.113",
    transform: "translate(-152.312 -174.983)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M1167.424,1564.9c-9.861,8.729-20.06,7.349-27.211-4.167-3-4.829-4.913-10.307-7.318-15.491q-3.145-12.7-6.3-25.389-2.131-9.089-4.263-18.178-1.9-7.222-3.8-14.444,1.451-1.283,2.893-2.565a6.805,6.805,0,0,1,1.343.435c5.981-.823,3.772-5.29,3.647-8.487-.163-4.182-1.213-8.325-1.493-12.51-.9-13.4,1.92-26.379,4.717-39.374.46-2.139-.311-4.533-.514-6.809l.808-3.667c3.932-4.783,3.244-9.682.384-14.636a.849.849,0,0,1-.23-1.062l-1.288-2.566c-2.508-3.472-2.664-6.618,1.326-9.188,7.337,1.089,14.089-1.3,20.636-3.874,4.356-1.716,7.224-1.1,10.632,2.081a424.506,424.506,0,0,1,50.582,56.38,756.227,756.227,0,0,0,91.73,101.587c2.639,2.454,5.99,4.172,9.01,6.232-6.161,3.893-12.115,8.162-18.544,11.565a120.328,120.328,0,0,1-17.865,7.391,21.384,21.384,0,0,0-10.28,6.794c-5.052,5.956-12.523,8.363-20.442,8.942l-29.574,0c-15.3-2.128-26.673-11.365-38.154-20.376-2.111-1.658-4.043-3.537-6.814-5.981l-3.624,7.361",
    transform: "translate(-166.924 -156.18)",
    fill: "#babab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M795.665,1008.674q-6.384-5.578-12.768-11.156c-6.3-6.269-12.566-12.569-18.936-18.766-.8-.775-2.138-1.01-3.224-1.5-1.4-1.711-2.7-3.521-4.235-5.105-1.814-1.869-3.834-3.545-5.768-5.3Q738.86,954.923,726.989,943l-11.034-11.577c-1.155-1.7-1.96-3.851-3.528-5.018-6.046-4.5-12.334-8.689-18.529-13q-2.036-3.413-4.079-6.821c-2.036-3.35-3.773-6.923-6.161-10.01-9.482-12.264-14.955-26.129-17.732-41.142,14.871,8.993,30.126,17.436,44.51,27.124,16.442,11.076,32.292,23.029,48.067,35.021,18.467,14.039,36.975,27.943,54.01,43.842,9.034,8.433,12.453,15.72,9.409,27.383-2.494,9.556-3.017,19.606-4.418,29.441-4-1.888-7.956-3.86-12-5.648-3.227-1.426-6.557-2.626-9.841-3.926",
    transform: "translate(-134.833 -109.497)",
    fill: "#c8c4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M539.387,827.63l-14.737,1.853q-7.442.79-14.885,1.576c-2.162-8.289.238-16.566.4-24.829.082-4.125,4.138-6.918,8.857-7.881,4.358-.89,8.587-2.389,12.875-3.619q.871-.03,1.738-.093c4.682,3.69,10.219,2.374,15.048,1.407,10.181-2.039,20.1-5.3,30.193-7.812,4.717-1.172,9.586-1.756,14.386-2.607,7.185,6.1,14.682,11.9,21.406,18.454,2.853,2.781,4.518,7.01,5.934,10.86,1.44,3.916,1.908,8.177,2.8,12.288l-9.7,2.106c-4.93.011-9.862.108-14.789.017-12.519-.233-14.873-3.668-10.31-14.821a6.621,6.621,0,0,0,.213-1.752c-4.351-.809-14.267,2.972-19.765,7.535-5.4,2.746-12.464,1.732-16.679,7.134l-.125-.043q-3.6-.141-7.2-.277-2.829.257-5.656.5",
    transform: "translate(-123.697 -103.307)",
    fill: "#a6a6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M1127.751,1398.346a.848.848,0,0,0,.232,1.062q-.191,7.317-.383,14.637l-.81,3.666a151.094,151.094,0,0,0-5.967,55.531c.314,3.849-.237,7.766-.391,11.652a6.753,6.753,0,0,0-1.343-.436c-1.82-3.812-4.321-7.46-5.33-11.469a81.98,81.98,0,0,1-1.065-35.165c1.822-9.948,2.968-20.015,4.414-30.03a7.159,7.159,0,0,0-4.038,4.227c-5.5,15.172-10.171,30.526-10.772,46.8-.2,5.447-.8,10.879-1.214,16.318-2.618-.6-4.037.389-4.12,3.048-.11,3.523.048,7.07-.323,10.565a88.793,88.793,0,0,1-1.865,9.055c-3.086-12.435-6.482-24.81-9.055-37.347-.715-3.49.488-7.642,1.745-11.169,1.666-4.673,3.093-9-.463-13.36a23.259,23.259,0,0,1,3.529-13l6.5-11.317q.531-3.628,1.061-7.255l-.036.317q1.005-.972,2.006-1.945l-.032.048q.93-.89,1.854-1.786l.083-.072q.842-.83,1.683-1.667s.244-.246.244-.24q4.5-4.18,8.994-8.367l7.947-11.051c4.027.7,5.736,3.617,6.957,7-3.989,2.568-3.833,5.715-1.326,9.186l1.288,2.566",
    transform: "translate(-164.582 -155.967)",
    fill: "#bd1214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M1211.648,1060.547c-8.618,3.61-10.281,11.328-10.99,19.1-.626,6.869,4.137,10.158,11.509,11.256-1.509,6.081-2.854,11.5-4.2,16.923-5.24-10.244-10.674-20.4-15.679-30.75q-13.284-27.479-26.086-55.18c-1.75-3.78-2.56-7.979-3.8-11.983,9.9,2.081,17.378,8.047,23.3,15.51,9.049,11.4,17.334,23.386,25.943,35.125",
    transform: "translate(-170.034 -123.192)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M1319.077,1459.212c3.131,10.72,6.516,21.376,9.326,32.177,3.181,12.222,5.869,24.569,8.686,36.88.18.79-.371,1.742-.587,2.621-.966-1.478-2.37-2.84-2.822-4.457q-11.958-42.847-23.645-85.766c-.275-1.008.375-2.258.589-3.395q3.214,7.278,6.433,14.555,1.009,3.692,2.02,7.385",
    transform: "translate(-180.497 -161.081)",
    fill: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M621.246,833.378q4.85-1.053,9.7-2.106,1.636,2,3.269,3.994a21.392,21.392,0,0,1-13.491,8.193c-1.431.223-3.074-.866-5.462-1.616l5.982-8.466",
    transform: "translate(-131.241 -107.354)",
    fill: "#8f9193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M1221.536,1137.4c7.83,1.494,8.07,1.917,5.328,9.346l-5.328-9.346",
    transform: "translate(-174.226 -134.495)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M1215.556,1125.4c5.729,1.922,6.1,2.665,3.664,7.3q-1.833-3.65-3.664-7.3",
    transform: "translate(-173.803 -133.431)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M493.763,717.54q-.011-.894-.05-1.786,3.76,1.761,7.522,3.519l-7.472-1.733",
    transform: "translate(-122.623 -97.113)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M1339.834,1542.295q.078,2.177.158,4.354c-2.808-1.355-2.63-2.814-.158-4.354",
    transform: "translate(-182.479 -170.392)",
    fill: "#8b8c8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M509.511,721.438l-7.754-1.85,7.754,1.85",
    transform: "translate(-123.193 -97.453)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M1561.259,856.882c-12.031,6.809-24.861,6.856-38.062,4.575-3.266-.564-6.688-.252-10.041-.341-16.293-5.516-32.688-10.753-48.843-16.633-14.74-5.365-29.212-11.44-43.814-17.171-3.134-1.23-6.324-2.323-9.487-3.472-5.165-7.963-13.516-10.328-22.192-12.123-.628-4.383-1.646-8.753-1.8-13.152-.276-8.054-.346-16.009-4.431-23.415-1.743-3.16-.557-4.041,4.263-3.682a67.993,67.993,0,0,0,7.157,3.69c15.766,5.97,31.76,11.4,47.342,17.8q39.6,16.256,78.761,33.534c13.48,5.947,26.459,13,36.824,23.708,1.817,1.876,2.9,4.438,4.32,6.684",
    transform: "translate(-185.592 -102.046)",
    fill: "#c8c4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M1742.722,559.406c.7.931,1.753,1.768,2.041,2.809,2.02,7.3,6.273,11.305,14.484,10.294,2.735-.336,5.674-.251,6.087,3.573-31.889,10.171-64.557,17.444-97.2,24.7-35.911,7.982-71.995,15.21-107.985,22.85-20.694,4.393-41.337,9.008-62.031,13.4-8.087,1.717-16.247,3.1-24.375,4.638l-46.318,3.635,7.318-5.462c37.831-9.826,75.689-19.556,113.478-29.538,11.839-3.128,23.493-6.934,35.231-10.43q7.378-1.81,14.754-3.622l11.126-2.032c28.976-7.9,57.907-15.969,86.945-23.648,15.388-4.069,30.96-7.468,46.45-11.17",
    transform: "translate(-188.824 -83.251)",
    fill: "#b1ada7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M1709.639,379.559c2.01,1.971,3.794,4.261,6.088,5.835,3.217,2.208,5.105,4.667,5.252,8.733.137,3.8,1.184,7.561,1.831,11.342-5.527,3.764-10.958,7.674-16.6,11.264-43.706,27.8-87.318,55.752-131.254,83.2-16.627,10.387-33.931,19.751-51.111,29.26-16.92,9.365-34.026,18.413-51.162,27.4-4.31,2.258-9.049,3.731-13.591,5.566q-1.937-5.581-3.877-11.167c7.437-4.208,14.9-8.378,22.311-12.63,29.309-16.809,59.04-32.962,87.775-50.671,26.859-16.551,53.01-34.276,78.764-52.449,12.458-8.791,23.357-19.722,34.838-29.819,8.735-7.681,17.234-15.619,25.942-23.329,1.308-1.159,3.182-1.7,4.794-2.533",
    transform: "translate(-190.795 -67.307)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M1516.116,753.736c1.483,1.19,2.821,3.152,4.47,3.446,11.752,2.094,23.681,3.343,35.324,5.88,8.3,1.809,17.126,3.619,22.738,11,2.457,3.227,4.318,6.891,7.3,11.745-11.55,2.309-21.374,4.237-31.175,6.268a42.781,42.781,0,0,0-5.2,1.768c-14.153-2.709-28.289-5.51-42.463-8.112-28.649-5.258-56.79-13.167-85.939-15.839a87.724,87.724,0,0,1-9.04-1.758c-.848-5.843-1.028-11.885-2.766-17.46-1.251-4.016-4.474-7.482-7.017-11.056a75.8,75.8,0,0,0-5.071-5.842c4.193.824,8.622,1.06,12.539,2.572,15.688,6.054,32.45,6.846,48.727,9.931,10.552,2,21.329,2.848,32.005,4.209q12.783,1.629,25.565,3.252",
    transform: "translate(-186.687 -98.71)",
    fill: "#c8c4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M1388.79,815.641c8.675,1.794,17.027,4.159,22.192,12.123,2.348,2.755,4.33,5.955,7.11,8.2,10.7,8.642,21.328,17.43,32.59,25.328a230.03,230.03,0,0,1,47.184,44.552c2.1,2.607,4.809,4.9,6.271,7.8a34.646,34.646,0,0,1,3.3,10.966c.456,3.524-1.958,5.54-5.652,5.767q-14.746.908-29.491,1.811c-7.412-1.375-9.343-8.231-12.91-13.1-7.293-9.956-13.313-20.816-20.713-30.686-5.383-7.181-12.139-13.371-18.282-20l-39-42.276,7.4-10.485",
    transform: "translate(-185.56 -105.969)",
    fill: "#b6b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M1584,600.8c-11.738,3.5-23.392,7.3-35.231,10.43-37.789,9.982-75.647,19.711-113.478,29.537-.6-8.193,2.795-15.172,6.793-22.02,1.642-2.812,2.9-5.839,4.335-8.77,2.424-.363,4.966-.38,7.252-1.138,20.138-6.677,40.214-13.527,60.339-20.245,18.941-6.323,37.916-12.547,56.876-18.815-1.767,12.837,4.016,22.6,13.115,31.02",
    transform: "translate(-189.377 -84.171)",
    fill: "#e1ddd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M1571.389,566.02c-18.96,6.268-37.935,12.493-56.876,18.816-20.124,6.718-40.2,13.567-60.338,20.245-2.286.758-4.829.776-7.252,1.137-1.493-4.97-2.987-9.943-4.6-15.329,4.558-4.812,11.627-4.745,17.732-6.922,26.386-7.072,53.109-13.14,79.054-21.523,21.289-6.881,41.673-16.471,62.42-24.95,7.917-3.234,15.728-6.717,23.586-10.089,3.505,4.4,6.989,8.816,5.747,14.976q-26.74,10.682-53.483,21.359c-1.982.791-3.989,1.521-5.984,2.279",
    transform: "translate(-189.88 -80.414)",
    fill: "#b6b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M1421.369,873.535c6.143,6.632,12.9,12.823,18.282,20,7.4,9.87,13.421,20.73,20.713,30.687,3.568,4.871,5.5,11.726,12.91,13.1q.035.853.11,1.705c-.818,5.71-3.558,9.17-9.961,9.774-4.805.454-9.5,2.026-14.245,3.1q-18.191-17.376-36.4-34.74c-5.74-5.446-11.606-10.765-17.416-16.141-1.116-8.324,2.593-13.213,10.479-16.5,5.815-2.422,13.506-3.108,15.524-10.993",
    transform: "translate(-186.538 -111.101)",
    fill: "#c8c4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M1349.706,1090.166c.248,5.18-5.326,4.456-7.532,7.148l-7.146,3.7q-3.734-12.261-7.469-24.523l1.545-1.14c2.771,2.5,5.683,4.874,8.28,7.54,3.463,3.555,7.082,6.688,12.322,7.273",
    transform: "translate(-181.744 -128.994)",
    fill: "#9c9b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M1358.834,1037.327c1.62,1.156,3.712,2,4.779,3.525,4.2,6.011,8.078,12.24,13.1,19.959l-10.272.368c-3.125-6.456-6.08-13-9.457-19.327-1.439-2.7-.791-3.81,1.852-4.524",
    transform: "translate(-183.777 -125.623)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M1365.269,1649.166a18.92,18.92,0,0,1,11.222,9.3c4.3,7.294,8.091,14.875,12.361,22.185,13.472,23.067,27.118,46.036,40.6,69.095q19.518,33.373,38.8,66.879c3.093,5.394,7.948,10.071,8.272,18.519-2.453-1.1-4.651-1.382-5.435-2.562-5.208-7.841-10.339-15.748-15.075-23.87-17.436-29.9-34.674-59.912-52.057-89.844-10.181-17.531-20.6-34.93-30.682-52.515-2.83-4.936-4.843-10.323-8.007-17.189",
    transform: "translate(-184.417 -179.867)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M1419.247,1597.284c1.914,1.271,4.343,2.16,5.663,3.871,15.219,19.731,30.143,39.683,45.4,59.383,15.071,19.455,30.519,38.63,45.614,58.067,3.345,4.308,5.856,9.233,8.836,13.821,4.627,7.123,9.521,14.087,13.9,21.355,1.653,2.746,2.177,6.145,3.214,9.246-5.484-5.669-11.581-10.888-16.336-17.094-13.3-17.355-26.177-35.026-38.955-52.757-8.342-11.574-16.169-23.5-24.334-35.2-2.772-3.972-5.917-7.693-8.813-11.585-9.962-13.4-19.964-26.764-29.763-40.276-1.912-2.637-2.973-5.869-4.427-8.827",
    transform: "translate(-188.245 -175.267)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M1223.454,1603.541l29.573,0-22.243,1.635-7.33-1.638",
    transform: "translate(-174.362 -175.822)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M1319.618,1460.628q-1.011-3.693-2.02-7.385c6.255,2.645,6.62,3.982,2.02,7.385",
    transform: "translate(-181.037 -162.496)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M1407.333,1581.29c4.89.2,5.738,3.337,5.5,7.268q-2.752-3.633-5.5-7.268",
    transform: "translate(-187.4 -173.849)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M1391.262,1559.3c3.6.071,5.464,1.862,5.576,5.4-3.556-.113-5.314-2.011-5.576-5.4",
    transform: "translate(-186.26 -171.899)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M1403.349,1575.316c3.819.083,3.7,2.734,3.629,5.354q-1.816-2.677-3.629-5.354",
    transform: "translate(-187.117 -173.319)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M1397.328,1565.3l3.638,5.385c-3.753-.143-3.687-2.771-3.638-5.385",
    transform: "translate(-186.69 -172.431)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M1306.7,1656.691v2.753l-.72,0v-2.752l.72,0",
    transform: "translate(-180.214 -180.534)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M1401.338,1571.314l1.766,3.511-1.766-3.511",
    transform: "translate(-186.975 -172.965)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M1308.821,1664.994c-.081.21-.162.419-.244.629l-.711-.724.527-.468.427.562",
    transform: "translate(-180.348 -181.22)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M866.854,664.76c5.938-9.119,12.267-11.62,20.519-8.11,8.467,3.6,11.955,11.14,9.561,20.665l-7.013-7.057c-5.933-8.338-7.428-8.8-17.029-5.253l-6.039-.244",
    transform: "translate(-149.079 -91.738)",
    fill: "#ede8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M889.429,688.528c-4.982,3.628-10.339,4.07-16.2,2.268-4.881-1.5-7.97-4.054-7.6-9.455l3.229.422c1.532,2.056,2.677,4.65,4.684,6.047,3.155,2.193,5.328.651,6.847-4.2q4.394-2.162,8.789-4.33c2.63,1.384,1.85,2.932.617,4.958-.674,1.108-.283,2.84-.373,4.29",
    transform: "translate(-148.99 -93.879)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M891.228,687.859c.089-1.45-.3-3.182.372-4.29,1.233-2.026,2.013-3.573-.618-4.957q.325-3.439.65-6.883,3.506,3.531,7.013,7.058c-.519,4.559-3.677,7.045-7.417,9.072",
    transform: "translate(-150.79 -93.21)",
    fill: "#d6d2ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M866.622,665.7q3.02.122,6.041.242a5.008,5.008,0,0,1,.039,1.477l-4.426,5.519-3.467,5.778c-2.4-4.742-1.018-8.976,1.813-13.017",
    transform: "translate(-148.846 -92.675)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M864.9,679.418l3.467-5.778q.467,3.618.933,7.236l-.489.387-3.228-.422a4.339,4.339,0,0,1-.683-1.423",
    transform: "translate(-148.941 -93.379)",
    fill: "#9c9b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M1086.716,1441.383c3.558,4.354,2.131,8.684.465,13.357-1.257,3.528-2.46,7.679-1.745,11.169,2.573,12.538,5.969,24.912,9.055,37.348q-.857.22-1.7.481c-6.566-6.1-8.961-14.219-11.3-22.368.065-10.547.024-21.1.265-31.638.066-2.891.973-5.765,1.495-8.645q1.738.149,3.471.294",
    transform: "translate(-164.296 -161.419)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M1117.329,1496.407q1.9,7.221,3.807,14.443c-3.855.129-8.226-1.157-10.389,3.635q-4.595-1.869-9.19-3.735c.814-.63,1.7-1.841,2.426-1.754,1.068.129,2.021,1.182,3.024,1.841l.86.369-.772-.453q-1.73-9.307-3.459-18.614l3.331-6.7c3.77,3.99,7.067,7.48,10.363,10.97",
    transform: "translate(-165.72 -165.351)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M1106.445,1510.732c-1-.66-1.955-1.713-3.024-1.842-.725-.088-1.612,1.123-2.425,1.753q-3.675-1.546-7.349-3.084c.568-.168,1.135-.329,1.708-.477a89.138,89.138,0,0,0,1.865-9.055c.371-3.495.213-7.042.322-10.565.083-2.658,1.5-3.651,4.115-3.057q.7,3.8,1.419,7.627,1.728,9.308,3.458,18.615Z",
    transform: "translate(-165.159 -165.245)",
    fill: "#65594c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M1111.448,1516.95c2.163-4.792,6.534-3.505,10.389-3.634q2.127,9.088,4.26,18.177c-10.278-.86-11.031-1.607-14.649-14.544",
    transform: "translate(-166.421 -167.817)",
    fill: "#6b5f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M1557.059,443.643c4.1-.241,6.239,1.449,5.816,5.67-5.9,4.756-11.655,9.687-17.713,14.235q-30.351,22.785-60.9,45.323a36.534,36.534,0,0,1-4.781,2.572l-.6-.664c3.655-3.549,7.141-7.285,10.995-10.613q20.089-17.345,40.4-34.441c8.844-7.453,17.844-14.728,26.774-22.083",
    transform: "translate(-192.474 -72.986)",
    fill: "#b6b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M1451.18,537.645c7-8.711,15.893-15.1,25.749-20.327,0,0,.589.655.591.659q-13.084,9.929-26.17,19.854Z",
    transform: "translate(-190.509 -79.52)",
    fill: "#b6b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M1491.7,459.878l-22.435,21.73.029.028c.151-.867-.015-2.04.5-2.554,6.875-6.844,12.328-15.228,21.636-19.466l.268.262",
    transform: "translate(-191.791 -74.404)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M1450.854,539.809l-5.133,5.37-1.536-1.714q3.25-1.919,6.5-3.841l.168.185",
    transform: "translate(-190.013 -81.498)",
    fill: "#b6b3ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M1459.317,491.25l7.413-5.469-.032-.032-7.437,5.447Z",
    transform: "translate(-191.082 -76.721)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M1497.291,455.953l-1.9,1.771-.291-.283q.9-.935,1.8-1.873l.394.386",
    transform: "translate(-193.623 -74.045)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M1495.247,457.907q-.928.894-1.855,1.792l-.265-.259c.61-.606,1.223-1.208,1.833-1.813l.286.28",
    transform: "translate(-193.483 -74.228)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M1459.232,491.726l-.381.8.436-.745-.055-.053",
    transform: "translate(-191.053 -77.251)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M1467.3,485.6l1.859-1.827-.028-.028q-.933.912-1.863,1.824l.031.031",
    transform: "translate(-191.649 -76.544)",
    fill: "#c5c1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M1453.3,958.26c4.744-1.075,9.44-2.646,14.245-3.1,6.4-.606,9.142-4.065,9.96-9.775,6.04-.921,10.1,1.991,14.506,5.8,9.913,8.577,15.72,19.794,22.339,30.553q1.767,6.422,3.529,12.841c-16.923.905-31.495-3.984-43.407-16.231-6.772-6.963-14.1-13.408-21.172-20.089",
    transform: "translate(-190.659 -117.456)",
    fill: "#babab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M1522.537,998.133q-1.763-6.419-3.529-12.843c3.5,4.424,7.646,8.5,10.329,13.364,3.437,6.222,5.694,13.071,8.459,19.65-3.638-5.327-7.2-10.707-10.962-15.949a34.2,34.2,0,0,0-4.3-4.222",
    transform: "translate(-195.318 -121.009)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M1544.8,1030.744l-5.577-9.224c5.339,1.051,5.46,5.136,5.577,9.224",
    transform: "translate(-196.751 -124.221)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M1622.36,597.248q-5.562,1.016-11.125,2.033c3.37-6.987,6.441-7.549,11.125-2.033",
    transform: "translate(-201.857 -86.276)",
    fill: "#e1ddd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M1097.394,1406.766q-.529,3.628-1.061,7.257c-1.267.335-3.109.263-3.7,1.07-2.3,3.14-4.2,6.558-6.25,9.873l-7.262,5.831q-1.711-4.468-3.42-8.937c5.689-4.084,11.359-8.188,17.071-12.236,1.474-1.044,3.078-1.91,4.622-2.858",
    transform: "translate(-163.887 -158.376)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M1079.368,1432.568l7.259-5.829q1.726.187,3.456.37a23.267,23.267,0,0,0-3.529,13q-1.736-.144-3.473-.292c-2.1-1.993-4.595-3.788-3.714-7.249",
    transform: "translate(-164.134 -160.147)",
    fill: "#c8c4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M515.495,896.294,546,885.832c-5.458,5.782-14,8.884-30.5,10.462",
    transform: "translate(-124.167 -112.191)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M555.692,830.819c4.215-5.4,11.284-4.388,16.679-7.134-1.32,1.287-2.416,3.182-4,3.74-4.111,1.445-8.438,2.3-12.678,3.394",
    transform: "translate(-127.017 -106.682)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M585.027,863.6c-.742,5.3-5.032,6.281-9.267,7.332l-.138-.158c.794-5.3,5.151-6.17,9.356-7.221Z",
    transform: "translate(-128.43 -110.216)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M570.888,873.641l-10.707,7.469-1.285-1.989a29.393,29.393,0,0,1,11.857-5.633l.135.153",
    transform: "translate(-127.244 -111.097)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M575.48,871.633q-1.845.914-3.689,1.829l-.134-.152,3.686-1.833.137.156",
    transform: "translate(-128.149 -110.919)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M593.554,857.57l-1.854,1.82.022.021q.927-.909,1.855-1.817Z",
    transform: "translate(-129.57 -109.686)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M593.72,857.521l.744-.77c-.043.158-.033.375-.137.458a2.556,2.556,0,0,1-.631.288l.024.024",
    transform: "translate(-129.711 -109.613)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M585.693,863.479l.847-.742c-.043.169-.031.4-.141.495a2.557,2.557,0,0,1-.657.295l-.048-.047",
    transform: "translate(-129.144 -110.144)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M591.642,859.568l-.771.739c.048-.155.048-.37.155-.451a2.569,2.569,0,0,1,.637-.267l-.022-.021",
    transform: "translate(-129.511 -109.863)",
    fill: "#71685e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M1484.468,1019.865c-7.065-3.755-7.89-10.87-9.872-17.363,5.183,4.747,7.922,10.826,9.962,17.286Z",
    transform: "translate(-192.169 -122.535)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M1501.41,1045.33q5.059.563,5.512,5.539l-.2.18c-3.463-.251-5.2-2.2-5.594-5.47Z",
    transform: "translate(-194.05 -126.332)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M1485.31,1021.469c3.236,1.419,3.871,4.139,3.76,7.234l-.166.161c-3.188-1.491-3.885-4.188-3.684-7.318l.09-.076",
    transform: "translate(-192.92 -124.217)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M1469.331,991.46l5.061,6c-6.064-.424-4.766-3.647-5.165-5.908l.1-.088",
    transform: "translate(-191.788 -121.556)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M1492.912,1035.025q-1.862-2.73-3.724-5.458l.165-.16c3.6.284,3.717,2.837,3.706,5.472Z",
    transform: "translate(-193.203 -124.921)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M1493.344,1035.412q1.857,1.831,3.713,3.661l-.172.149-3.688-3.666.147-.144",
    transform: "translate(-193.488 -125.453)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1500.844,1045.055q-1.837-2.74-3.677-5.478l.171-.149q1.893,2.69,3.787,5.381l-.282.246",
    transform: "translate(-193.769 -125.809)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1510.961,1055.135q-1.906-1.776-3.813-3.55l.2-.18q1.817,1.854,3.632,3.707l-.02.022",
    transform: "translate(-194.477 -126.871)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M1467.3,987.5q.946,1.807,1.894,3.613l-.1.087-1.828-3.664Z",
    transform: "translate(-191.649 -121.205)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M1464.747,981.351l-.246.651-.731-.751q.27-.242.54-.485l.438.585",
    transform: "translate(-191.401 -120.608)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M1515.255,1059.486l.762.746c-.16-.042-.38-.036-.466-.139a2.449,2.449,0,0,1-.286-.615Z",
    transform: "translate(-195.052 -127.587)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M1515.123,1059.3q-.929-.909-1.861-1.817h0l1.853,1.825Z",
    transform: "translate(-194.911 -127.41)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M1513.119,1057.306l-1.867-1.809.02-.022,1.847,1.832Z",
    transform: "translate(-194.768 -127.232)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M1467.2,987.458l-.774-.8c.169.04.4.027.494.132a2.514,2.514,0,0,1,.317.635l-.037.037",
    transform: "translate(-191.59 -121.13)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M1114.287,1391.721q-4.5,4.186-9,8.367,4.5-4.189,9-8.367",
    transform: "translate(-165.985 -157.042)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M1104.9,1401.166q-.842.835-1.682,1.667.84-.837,1.682-1.667",
    transform: "translate(-165.838 -157.88)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M1102.99,1403.074q-.927.894-1.854,1.786.925-.9,1.854-1.786",
    transform: "translate(-165.69 -158.049)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M1101.017,1404.98l-2.006,1.946q1-.974,2.006-1.946",
    transform: "translate(-165.539 -158.218)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M1403.3,1102.061c7.945,7.486,13.786,16.458,20.934,26.308-7.689-3.034-19.831-18.2-20.934-26.308",
    transform: "translate(-187.114 -131.362)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M1391.37,1085.409c4.695,2.584,6.69,6.959,9.434,12.865-7.583-2.629-9.152-7.293-9.548-12.753Z",
    transform: "translate(-186.26 -129.886)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M1379.361,1067.425l7.41,9.17c-6.635-.467-7.225-4.676-7.5-9.081Z",
    transform: "translate(-185.41 -128.291)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M1391.043,1085.254l-2.794-2.266.6-.591q1.153,1.374,2.306,2.746l-.113.111",
    transform: "translate(-186.047 -129.618)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M1379.211,1067.477l-.767-.473.858.384-.091.089",
    transform: "translate(-185.352 -128.254)",
    fill: "#7a7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M335.9,589.615c6.532,3.307,13.335,6.191,19.544,10.006C370.056,608.6,384.4,618,398.8,627.3c1.12.722,1.9,1.943,1.836,4.407-8.793-4.71-17.911-8.925-26.3-14.244C361.943,609.6,350.053,600.979,338,592.611a12.454,12.454,0,0,1-2.243-2.834Z",
    transform: "translate(-111.423 -85.93)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M335.334,589.425q-2.765-1.837-5.531-3.674l.087-.1q2.794,1.8,5.589,3.611l-.145.159",
    transform: "translate(-111.001 -85.579)",
    fill: "#c0bcb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M718.912,938.815l11.034,11.576c-2.129,27.663-4.051,55.3-13.087,81.972a154.3,154.3,0,0,0-8.127,41.563c-2.681-9.123.286-18.016,1.148-26.972.981-10.185,2.193-20.349,3.369-30.515,1.073-9.271,2.479-18.511,3.291-27.8,1-11.428,1.618-22.892,2.223-34.349.271-5.146.113-10.314.149-15.472",
    transform: "translate(-137.79 -116.889)",
    fill: "#6c787c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M529.376,793.589c-.58.042-1.159.073-1.74.093h-1.78l-1.822-.017c-22.18.612-44.36,1.253-66.541,1.8-2.9.072-5.812-.338-8.745-.527.18-4.36,2.687-4.561,5.144-4.976,4.289-.724,5.59-3.065,4.253-7.211-.728-2.255-.709-4.742-1.026-7.122,19.08.543,38.169,1.711,57.238,1.437,16.553-.238,33.078-2.154,49.623-3.212a64.372,64.372,0,0,1,8.029.49c-.071,5.182-3.322,5.8-6.2,6.378-7.215,1.442-14.6,2.191-21.692,4.065-5.6,1.48-12.724,1.259-14.742,8.8",
    transform: "translate(-119.434 -102.261)",
    fill: "#9c9b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M529.779,795.595l1.822.017q-.911-.014-1.822-.017",
    transform: "translate(-125.18 -104.191)",
    fill: "#a6a6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M541.716,831.667q2.828-.25,5.656-.5c-1.648,2.711-3.549,2.714-5.656.5",
    transform: "translate(-126.026 -107.345)",
    fill: "#838789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M1103.685,1485.5q-.712-3.818-1.418-7.627c.421-5.429,1.017-10.861,1.218-16.308.6-16.274,5.277-31.626,10.772-46.8a7.152,7.152,0,0,1,4.038-4.227c-1.446,10.015-2.592,20.081-4.415,30.03a81.992,81.992,0,0,0,1.066,35.165c1.01,4.009,3.51,7.657,5.33,11.469q-1.444,1.281-2.893,2.565c-3.3-3.489-6.6-6.979-10.368-10.969l-3.331,6.7",
    transform: "translate(-165.77 -158.71)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M1123.09,1488.6c.153-3.886.705-7.8.391-11.652a151.072,151.072,0,0,1,5.966-55.531c.2,2.277.974,4.671.514,6.81-2.8,13-5.614,25.978-4.717,39.376.279,4.185,1.329,8.328,1.493,12.51.125,3.2,2.335,7.664-3.648,8.487",
    transform: "translate(-167.24 -159.675)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M1130.811,1415.972q.192-7.32.384-14.637c2.861,4.955,3.547,9.854-.384,14.637",
    transform: "translate(-167.794 -157.895)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M1130.876,1399.92q-.644-1.283-1.289-2.566.645,1.284,1.289,2.566",
    transform: "translate(-167.707 -157.542)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M1090.651,1426.045q-1.73-.184-3.456-.37c2.053-3.317,3.954-6.737,6.253-9.875.592-.808,2.434-.735,3.7-1.07l-6.5,11.316",
    transform: "translate(-164.701 -159.082)",
    fill: "#aaa7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M873.4,667.236a5.016,5.016,0,0,0-.039-1.477c9.6-3.544,11.094-3.083,17.027,5.255q-.325,3.443-.65,6.883l-8.787,4.33-3.851-3.051c.328-4.446.913-8.968-3.7-11.94",
    transform: "translate(-149.54 -92.495)",
    fill: "#751313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M876.794,680.685l3.851,3.051c-1.52,4.851-3.693,6.392-6.848,4.2-2.009-1.4-3.153-3.989-4.685-6.046l.489-.387,7.193-.816",
    transform: "translate(-149.239 -94.004)",
    fill: "#9c9b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M876.76,679.523l-7.193.816q-.467-3.617-.933-7.236l4.426-5.519c4.614,2.972,4.028,7.494,3.7,11.939",
    transform: "translate(-149.205 -92.842)",
    fill: "#bd1214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M1107.51,1513.217l.773.452-.862-.368.088-.084",
    transform: "translate(-166.135 -167.814)",
    fill: "#65594c"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundRegistration);
export default __webpack_public_path__ + "static/media/Background-registration.c073506fdd0a1c5536ae54a5b575f6a2.svg";
export { ForwardRef as ReactComponent };